export const es = {
  // Common
  common: {
    save: 'Guardar',
    saving: 'Guardando...',
    cancel: 'Cancelar',
    delete: 'Eliminar',
    edit: 'Editar',
    view: 'Ver',
    add: 'Agregar',
    create: 'Crear',
    update: 'Actualizar',
    search: 'Buscar',
    filter: 'Filtrar',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    confirm: 'Confirmar',
    yes: 'Sí',
    no: 'No',
    close: 'Cerrar',
    back: 'Atrás',
    next: 'Siguiente',
    previous: 'Anterior',
    actions: 'Acciones',
    status: 'Estado',
    active: 'Activo',
    inactive: 'Inactivo',
    name: 'Nombre',
    email: 'Correo',
    phone: 'Teléfono',
    date: 'Fecha',
    time: 'Hora',
    description: 'Descripción',
    price: 'Precio',
    total: 'Total',
    submit: 'Enviar',
    reset: 'Restablecer',
    clear: 'Limpiar',
    refresh: 'Actualizar',
    export: 'Exportar',
    import: 'Importar',
    print: 'Imprimir',
    download: 'Descargar',
    upload: 'Subir',
    select: 'Seleccionar',
    selectAll: 'Seleccionar Todo',
    deselectAll: 'Deseleccionar Todo',
    none: 'Ninguno',
    all: 'Todos',
    required: 'Requerido',
    optional: 'Opcional',
    delete: 'Eliminar',
    authorization:'Autorización',
    reprint:'Reimpresión',
    addItem:'Agregar Artículo',
    qty:'Cantidad',
    discount:'Descuento',
    itemDescription:'Descripción Artículo',
    type:'Tipo',
    selectType:'Seleccionar tipo',
    english: 'Inglés',
    spanish: 'Español',
    register: 'Registrar',
    login: 'Iniciar Sesión',
    registering: 'Registrando...',
    snackbar: {
      pleaseFillAllRequiredFields: 'Por favor completa todos los campos requeridos',
      nameRequired: 'El nombre es requerido',
      typeRequired: 'El tipo es requerido',
      commentRequired: 'El comentario es requerido',
    },
  },

  // Navigation
  nav: {
    menus: 'Menú digital',
    loyalty: 'Lealtad',
    loyaltyCashier: 'Caja',
    loyaltyMembers: 'Miembros',
    loyaltyRewards: 'Recompensas',
    loyaltyPromotions: 'Promociones',
    loyaltyTransactions: 'Transacciones',
    loyaltySettings: 'Configuración del programa',
    dashboard: 'Panel de Control',
    clients: 'Clientes',
    cleaningDetails: 'Trabajos de limpieza',
    services: 'Servicios',
    serviceTypes: 'Tipos de Servicio',
    serviceHistory: 'Historial de Servicios',
    invoices: 'Facturas',
    calendar: 'Calendario',
    jobSchedule: 'Cronograma de trabajos',
    visits: 'Visitas',
    settings: 'Configuración',
    profile: 'Perfil',
    logout: 'Cerrar Sesión',
    login: 'Iniciar Sesión',
    budgetConfig: 'Configuración de Presupuesto',
    types: 'Tipos',
    units: 'Unidades',
    products: 'Productos',
    students: 'Estudiantes',
    employees: 'Empleados',
    cycles: 'Ciclos',
    grades: 'Grados',
    cursos: 'Cursos',
    pensums: 'Pensum',
    notas: 'Notas',
    attendance: 'Asistencia',
    markAttendance: 'Marcar asistencia',
    teacherAssignments: 'Asignaciones de docentes',
    planification: 'Planificación',
    planifications: 'Planificaciones',
    descounts: 'Descuentos',
    paymentTypes: 'Tipos de Pago',
    memberships: 'Membrecía',
    payments: 'Pagos',
    administration: 'Administración',
    userManagement: 'Gestión de Usuarios',
    tenantUsers: 'Usuarios de Tenants',
    tenantManagement: 'Gestión de Tenants',
    tenantRegistration: 'Registro de Tenant',
    tenantRoles: 'Roles por Tenant',
    rolesPermissions: 'Roles y Permisos',
    permissionManagement: 'Gestión de Permisos',
    emailTemplates: 'Plantillas de Correo',
    clientEmailSettings: 'Configuración de Correo de Cliente',
    emailQueue: 'Cola de Correo',
    systemSettings: 'Configuración del Sistema'
  },

  visitHistory: {
    title: 'Historial del Paciente',
    newVisit: 'Nueva Visita',
    saving: 'Guardando...',
    save: 'Guardar',
    edit: 'Editar',
    print: 'Imprimir',
    printTime: 'Hora',
    printPopupBlocked: 'Permite las ventanas emergentes del navegador para imprimir.',
    dob: 'Fecha de Nacimiento',
    na: 'N/A',
    contactInfo: 'Información de Contacto',
    phone: 'Teléfono',
    medicalSummary: 'Resumen Médico',
    allergiesNotes: 'Alergias y Notas',
    noMedicalSummary: 'No hay resumen médico disponible.',
    noAllergies: 'No hay alergias registradas.',
    changePhoto: 'Cambiar foto',
    uploadPhoto: 'Subir foto del paciente',
    removePhoto: 'Quitar foto',
    confirmRemovePhoto: '¿Quitar la foto del paciente y usar el logo de la empresa?',
    photoUploading: 'Subiendo foto...',
    photoUploadSuccess: 'Foto actualizada.',
    photoRemovedSuccess: 'Foto eliminada. Se usará el logo de la empresa.',
    timeline: 'Línea de Tiempo de Visitas',
    timelinePendingBadge: '{count} resultado(s) de examen pendiente(s)',
    timelinePendingBadgeShort: 'Resultados pendientes',
    visitType: 'Tipo de Visita',
    status: 'Estado',
    duration: 'Duración',
    defaultDuration: '45 minutos',
    tabs: {
      consultationNotes: 'Notas de Consulta',
      prescribedExams: 'Exámenes Prescritos',
      prescription: 'Receta',
      invoices: 'Facturas',
    },
    consultation: {
      chiefComplaint: 'Motivo de Consulta',
      chiefComplaintPlaceholder: 'Motivo principal del paciente para la consulta...',
      physicalExamination: 'Examen Físico',
      physicalExaminationPlaceholder: 'Hallazgos del examen físico...',
      assessmentPlan: 'Evaluación y Plan',
      assessmentPlanPlaceholder: 'Evaluación del médico y plan de tratamiento...',
    },
    exams: {
      addNewExam: 'Agregar nuevo examen',
      addExam: 'Agregar examen',
      prescribedForVisit: 'Exámenes prescritos en esta visita',
      empty: 'Aún no hay exámenes prescritos. Agrega uno para comenzar.',
      cancel: 'Cancelar',
      saveExams: 'Guardar exámenes',
      printOrders: 'Imprimir órdenes de examen',
      unknownExam: 'Examen desconocido',
      unknownStatus: 'Estado desconocido',
      unknownPriority: 'Prioridad desconocida',
      noReason: 'Sin indicación clínica',
      requested: 'Solicitado',
      notes: 'Notas',
      editExam: 'Editar examen',
      newExam: 'Nuevo examen',
      examType: 'Tipo de examen',
      selectExamType: 'Seleccionar tipo de examen...',
      searchExamType: 'Buscar o escribir un examen nuevo...',
      addExamTypeOption: 'Agregar "{name}"',
      examTypeRequired: 'Selecciona o agrega un tipo de examen.',
      createExamTypeFailed: 'No se pudo crear el tipo de examen. Inténtalo de nuevo.',
      saveFailed: 'No se pudo guardar el examen. Revisa la prioridad e inténtalo de nuevo.',
      saved: 'Examen guardado correctamente.',
      visitRequiredForExam: 'Selecciona una visita guardada (no solo una cita del calendario) para prescribir exámenes.',
      priority: 'Prioridad',
      selectPriority: 'Seleccionar prioridad...',
      status: 'Estado',
      selectStatus: 'Seleccionar estado...',
      requestedDate: 'Fecha solicitada',
      reason: 'Indicación clínica / Motivo',
      reasonPlaceholder: '¿Por qué se necesita este examen? Indicación clínica...',
      resultNotes: 'Resultado / Notas',
      resultNotesPlaceholder: 'Ingresa resultados del examen o notas adicionales...',
      notesAutoCompleteStatus: 'Al ingresar el resultado, el estado cambia a Completado.',
      expectedCompletion: 'Finalización esperada',
      updateExam: 'Actualizar examen',
      saveExam: 'Guardar examen',
      deleteConfirm: '¿Seguro que deseas eliminar este examen?',
      statuses: {
        ordered: 'Ordenado',
        completed: 'Completado',
        pending: 'Pendiente',
      },
      priorities: {
        urgent: 'Urgente',
        routine: 'Rutina',
        specific: 'Específico',
        most: 'Mayor',
      },
      types: {
        chestXray: 'Radiografía de tórax',
        glucose: 'Glucosa',
        bloodCells: 'Glóbulos',
        insulin: 'Insulina',
      },
    },
    prescriptions: {
      additionalNotesTitle: 'Notas e instrucciones adicionales',
      additionalNotesPlaceholder: 'Instrucciones adicionales, advertencias o notas para el paciente...',
      drugWarningsTitle: 'Interacciones y advertencias de medicamentos',
      warningTitle: 'Título de la advertencia',
      warningDetail: 'Detalle / recomendación',
      addWarning: 'Agregar advertencia',
      noWarnings: 'No hay advertencias de interacciones registradas en esta visita.',
      saveNotes: 'Guardar notas y advertencias',
      saving: 'Guardando...',
      saved: 'Notas y advertencias de la receta guardadas.',
      saveFailed: 'No se pudieron guardar las notas de la receta. Inténtalo de nuevo.',
      visitRequired: 'Selecciona una visita guardada para agregar notas de receta.',
    },
    pendingExams: {
      title: 'Resultados de exámenes pendientes',
      line: '{exam} del {date} — resultados aún pendientes. Seguimiento requerido.',
      followUp: 'Seguimiento requerido.',
    },
    selectVisitPrompt: 'Selecciona una visita en la línea de tiempo para ver los detalles',
    createFirstVisit: 'Crear primera visita',
    common: {
      visit: 'Visita',
      unknownPatient: 'Paciente desconocido',
      doctor: 'Médico',
      license: 'Licencia',
      date: 'Fecha',
      history: 'Historial',
      client: 'Cliente',
      auth: 'Autorización',
      preview: 'Vista previa',
      saveDraft: 'Guardar borrador',
      id: 'ID',
    },
    visitStatuses: {
      done: 'Realizada',
      confirmed: 'Confirmada',
      scheduled: 'Programada',
      cancelled: 'Cancelada',
      passed: 'Pasada',
    },
    visitTypes: {
      review: 'Visita de revisión',
      emergency: 'Visita de emergencia',
      followUp: 'Seguimiento',
      consultation: 'Consulta',
    },
    appointment: {
      plannedTitle: 'Cita planificada',
      scheduledFromCalendar: 'Programada desde el calendario',
      routineCheckup: 'Control de rutina',
    },
    prescriptionTab: {
      title: 'Receta médica',
      prescriptionId: 'ID de receta',
      validUntil: 'Válida hasta',
      patientInfo: 'Información del paciente',
      clinicInfo: 'Información de la clínica',
      clinicName: 'Clínica MedCenter',
      clinicAddress: '123 Calle Salud, Ciudad Médica',
      addNewMedication: 'Agregar nuevo medicamento',
      addMedication: 'Agregar medicamento',
      currentPrescriptions: 'Recetas actuales',
      empty: 'Aún no hay recetas. Agrega un medicamento para comenzar.',
      dosage: 'Dosis y cantidad',
      frequency: 'Frecuencia',
      duration: 'Duración',
      noInstructions: 'Sin instrucciones',
      printPrescription: 'Imprimir receta',
      medicationStatuses: {
        active: 'Activa',
        completed: 'Completada',
        cancelled: 'Cancelada',
        extended: 'Extendida',
      },
      dialog: {
        editTitle: 'Editar receta',
        newTitle: 'Agregar nueva receta',
        medicationName: 'Nombre del medicamento',
        medicationPlaceholder: 'Ingresa el nombre del medicamento',
        dosage: 'Dosis y cantidad',
        dosagePlaceholder: 'ej., 2.5 mg por toma · 20 tabletas',
        dosageHelper: 'Incluye la dosis por toma y el total a dispensar (tabletas, ml, etc.).',
        frequency: 'Frecuencia',
        frequencyPlaceholder: 'ej., Una vez al día, cada 12 h, según necesidad',
        duration: 'Duración',
        durationPlaceholder: 'ej., 7 días',
        instructions: 'Instrucciones',
        instructionsPlaceholder: 'Tomar con alimentos...',
        extraNotes: 'Notas adicionales',
        extraNotesPlaceholder: 'Notas adicionales...',
        status: 'Estado',
        durationHistory: 'Historial de duración',
        durationHistoryPlaceholder: 'Cambios previos de duración...',
        cancel: 'Cancelar',
        save: 'Guardar receta',
        update: 'Actualizar receta',
        deleteConfirm: '¿Seguro que deseas eliminar esta receta?',
        selectFrequency: 'Seleccionar frecuencia...',
        frequencyOnceDaily: 'Una vez al día',
        frequencyTwiceDaily: 'Dos veces al día',
        frequencyThreeDaily: 'Tres veces al día',
        frequencyFourDaily: 'Cuatro veces al día',
        frequencyAsNeeded: 'Según necesidad',
        frequencyEveryOtherDay: 'Día por medio',
        instructionsPlaceholder: 'Instrucciones especiales para tomar este medicamento...',
        durationPlaceholderDays: 'ej., 30 días',
        quantityPlaceholderShort: 'ej., 30',
        savePrescription: 'Guardar receta',
        updatePrescription: 'Actualizar receta',
      },
    },
    invoiceTab: {
      logoTitle: 'Logo del centro médico',
      uploadLogo: 'Subir logo de la clínica',
      logoFromSettings: 'Logo configurado en Ajustes del sistema',
      uploadLogoInSettings: 'Configura el logo en Ajustes del sistema',
      clinicName: 'Nombre de la clínica',
      address: 'Dirección',
      nitTaxId: 'NIT / ID fiscal',
      invoiceDate: 'Fecha de factura',
      invoiceInfo: 'Información de la factura',
      invoiceNumber: 'Número de factura',
      dueDate: 'Fecha de vencimiento',
      patientInfo: 'Información del paciente',
      fullName: 'Nombre completo',
      clientNit: 'NIT / ID del cliente',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      serviceDetails: 'Detalle de servicios',
      newInvoice: 'Nueva factura',
      empty: 'Aún no hay facturas. Crea una nueva factura para comenzar.',
      invoiceNumberShort: 'Factura #{id}',
      dateLine: 'Fecha',
      nit: 'NIT',
      generateInvoice: 'Generar factura',
      summary: 'Resumen de factura',
      totalItems: 'Total de ítems',
      visitLabel: 'Visita',
      dialog: {
        editTitle: 'Editar factura',
        newTitle: 'Nueva factura',
        createTitle: 'Crear nueva factura',
        deleteConfirm: '¿Seguro que deseas eliminar esta factura?',
        saveInvoice: 'Guardar factura',
        updateInvoice: 'Actualizar factura',
        cancel: 'Cancelar',
        description: 'Descripción',
        quantity: 'Cantidad',
        unitPrice: 'Precio unitario',
        discount: 'Descuento %',
        paymentTerms: 'Condiciones de pago',
        notes: 'Notas',
        status: 'Estado',
        headerTitle: 'Encabezado de factura',
        detailsTitle: 'Detalle de factura',
        addItem: 'Agregar ítem',
        total: 'Total',
        actions: 'Acciones',
        subtotal: 'Subtotal',
        tax: 'Impuesto (8.5%)',
        grandTotal: 'Total',
        notesPlaceholder: 'Notas adicionales para la factura...',
        invoiceStatuses: {
          draft: 'Borrador',
          sent: 'Enviada',
          paid: 'Pagada',
          overdue: 'Vencida',
          cancelled: 'Cancelada',
        },
      },
    },
    errors: {
      saveVisit: 'No se pudo guardar la visita. Revisa los valores del formulario.',
      saveMedical: 'No se pudieron guardar los datos médicos.',
      uploadPhoto: 'No se pudo subir la foto. Usa una imagen menor a 2 MB.',
      removePhoto: 'No se pudo quitar la foto.',
    },
    form: {
      visitTitle: 'Título de la visita',
      schedule: 'Fecha y hora',
      nextAppointment: 'Fecha de próxima cita',
      nextAppointmentHint: 'Se envía un recordatorio 3 días antes (si está activado).',
      editVisit: 'Editar visita',
      newVisit: 'Nueva visita',
      optional: 'opcional',
      requiredTitleSchedule: 'El título y la fecha/hora de la visita son obligatorios.',
      invalidSchedule: 'La fecha/hora tiene un formato no válido.',
      clientRequired: 'Selecciona un paciente antes de guardar la visita.',
      saveVisit: 'Guardar visita',
      updateVisit: 'Actualizar visita',
    },
  },

  // Settings page
  settings: {
    companyLogo: 'Logo de la Empresa',
    companyLogoDescription: 'Sube el logo de tu empresa para mostrarlo en presupuestos PDF y otros documentos. Tamaño recomendado: 200x200px. Tamaño máximo: 2MB.',
    selectLogo: 'Seleccionar Logo',
    uploadLogo: 'Subir Logo',
    removeLogo: 'Quitar Logo',
    logoUploadedSuccess: '¡Logo subido correctamente!',
    logoRemovedSuccess: '¡Logo eliminado correctamente!',
    currencyUpdatedSuccess: '¡Moneda actualizada correctamente!',
    currencySettings: 'Configuración de Moneda',
    currencyDescription: 'Selecciona la moneda que se mostrará en todo el sistema para todos los valores monetarios.',
    currency: 'Moneda',
    savingCurrency: 'Guardando moneda...',
    confirmRemoveLogo: '¿Estás seguro de que deseas eliminar el logo?',
    pleaseSelectImage: 'Por favor selecciona un archivo de imagen',
    fileSizeMax: 'El tamaño del archivo debe ser menor a 2MB',
    pleaseSelectLogo: 'Por favor selecciona un archivo de logo',
    failedUploadLogo: 'Error al subir el logo',
    failedUpdateCurrency: 'Error al actualizar la moneda',
    failedRemoveLogo: 'Error al eliminar el logo',
    themeSettings: 'Colores y tema',
    themeDescription: 'Define el modo claro/oscuro y los colores principales para toda la aplicación (menú, visitas, facturas, etc.).',
    themeMode: 'Modo de interfaz',
    themeModeLight: 'Claro',
    themeModeDark: 'Oscuro',
    primaryColor: 'Color primario',
    secondaryColor: 'Color secundario',
    saveTheme: 'Guardar tema',
    savingTheme: 'Guardando tema...',
    themeUpdatedSuccess: 'Tema actualizado. La interfaz ya usa los nuevos colores.',
    failedUpdateTheme: 'No se pudo actualizar el tema.',
    clinicInfo: 'Información de la clínica',
    clinicInfoDescription: 'Se muestra en las recetas y se usa como encabezado predeterminado para nuevas facturas. Editar esto no cambia las facturas existentes.',
    clinicName: 'Nombre de la clínica',
    clinicAddress: 'Dirección',
    clinicPhone: 'Teléfono',
    clinicEmail: 'Correo electrónico',
    clinicNit: 'NIT',
    providerName: 'Nombre del doctor / médico',
    providerNameHint: 'Déjalo vacío para usar el nombre del usuario conectado.',
    providerLicense: 'Número de licencia',
    saveClinic: 'Guardar información',
    clinicUpdatedSuccess: 'Información de la clínica actualizada.',
    failedUpdateClinic: 'No se pudo actualizar la información de la clínica.',
    senderEmail: 'Correo remitente',
    senderEmailDescription: 'La identidad "De" usada en correos automáticos (recordatorios, cumpleaños). Solo superadmin.',
    senderName: 'Nombre del remitente',
    senderEmailAddress: 'Correo del remitente',
    senderEmailHint: 'Debe estar verificado en AWS SES antes de usarse como dirección real de envío.',
    senderVerified: 'Dirección verificada en SES',
    senderVerifiedHint: 'Actívalo solo cuando esta dirección esté verificada en la consola de AWS SES. Hasta entonces, los correos se envían desde la dirección predeterminada y esta se usa como Responder-a.',
    saveSender: 'Guardar remitente',
    senderUpdatedSuccess: 'Correo remitente actualizado.',
    failedUpdateSender: 'No se pudo actualizar el correo remitente.',
  },

  // Login
  login: {
    title: 'Techno',
    welcomeMessage: '¡Bienvenido! Por favor inicia sesión en tu cuenta',
    emailAddress: 'Correo Electrónico',
    password: 'Contraseña',
    signIn: 'Iniciar Sesión',
    forgotPassword: '¿Olvidaste tu contraseña?',
    resetPassword: 'Restablecer Contraseña',
    enterEmailMessage: 'Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.',
    sendResetLink: 'Enviar Enlace',
    passwordResetSuccess: 'Se ha enviado el enlace para restablecer la contraseña a tu correo electrónico.',
    passwordResetError: 'No se pudo enviar el correo. Por favor intenta de nuevo.',
  },

  // Dashboard
  dashboard: {
    title: 'Panel de Control',
    totalClients: 'Total de Clientes',
    servicesCompleted: 'Servicios Completados',
    totalIncome: 'Ingresos Totales',
    recentActivities: 'Actividades Recientes',
    thisMonth: 'Este Mes',
    lastMonth: 'Mes Pasado',
    newCustomers: 'Nuevos Clientes este mes',
    moreServices: 'Más Servicios',
    lessServices: 'Menos Servicios',
    moreIncome: 'Más Ingresos',
    lessIncome: 'Menos Ingresos',
    nodata:'No hay datos disponibles',
    Welcome: 'Bienvenido de nuevo',
    msgwelcome:'Esto es lo que está sucediendo hoy con Techno.',
    msgchangeclients:'No hay cambios en clientes este mes',
    msgservicesame:'Misma cantidad de servicios completados este mes',
    msgservicemore:'Más servicios completados este mes',
    msgservicefewer:'Menos servicios completados este mes',
    msgincomesame:'Mismos ingresos que el mes pasado',
    yourprofile:'Tu Perfil',
    yourroles: 'Tus roles',
    keyp: 'Permisos clave',

  },

  // Clients
  clients: {
    title: 'Clientes',
    searchPlaceholder: 'Buscar por nombre, teléfono, correo o cualquier campo…',
    clearSearch: 'Borrar',
    showingClients: 'Mostrando {filtered} de {total} clientes',
    noSearchResults: 'Ningún cliente coincide con tu búsqueda.',
    openCleaningDetails: 'Trabajos de limpieza de este cliente',
    client:'Cliente',
    addClient: 'Agregar Nuevo Cliente',
    editClient: 'Editar Cliente',
    deleteClient: 'Eliminar Cliente',
    clientName: 'Nombre del Cliente',
    clientEmail: 'Correo del Cliente',
    clientPhone: 'Teléfono del Cliente',
    lastVisit: 'Última visita',
    nextVisit: 'Próxima visita',
    addService: 'Agregar Servicio',
    serviceType: 'Tipo de Servicio',
    serviceDate: 'Fecha del Servicio',
    noClientsFound: 'No se encontraron clientes',
    createFirstClient: 'Crea tu primer cliente para comenzar',
    clientDetails: 'Detalles del Cliente',
    customFields: 'Campos Personalizados',
    fieldConfiguration: 'Configuración de Campos',
    msjconffield:'Configure campos personalizados para formularios de clientes. Estos campos aparecerán al crear o editar clientes.',
    addfield:'Agregar campo',
    namefield:'Nombre del campo',
    Typefield: 'Tipo',
    emailfield:'Correo',
    datefield: 'Fecha',
    actionsfield:'Acciones',
    msjnoconffield:'No hay campos configurados',
    msjaddfield:'Agregue su primer campo personalizado para comenzar',
    cancel: 'Cancelar',
    csave:'Guardar',
    cupdate:'Actualizar',
    condele:'Confirmar eliminación',
    msgdele:'¿Está seguro de que desea eliminar este cliente? Esta acción no se puede deshacer.',
    vhistory:'Historial de visitas',
    msjnovisit:'No visits found for this client.',
    addservadvform:'Agregar servicio - Formulario avanzado',
    selecservice:'Seleccionar servicio...',
    value:'Valor',
    sservice:'Guardar servicio',
    allclients:'Todos los clientes',
    fields:'Campos',
    field:'Campo',
    fieldLabel:'Etiqueta del Campo',
    fieldType:'Tipo de Campo',
    options:'Opciones',
    optionsPlaceholder:'e.g., Small, Medium, Large',
    sendAnniversaryEmail: 'Enviar correo automático a clientes en esta fecha con la plantilla seleccionada',
    updateField:'Actualizar Campo',
    createField:'Crear Campo',
    deleteField:'Eliminar Campo',
    deleteFieldConfirm:'¿Estás seguro de que quieres eliminar este campo? Esta acción no se puede deshacer.',
    deleteFieldSuccess:'Campo eliminado correctamente',
    deleteFieldError:'Error al eliminar el campo',
    deleteFieldConfirmation:'¿Estás seguro de que quieres eliminar este campo? Esta acción no se puede deshacer.',
    deleteFieldSuccess:'Campo eliminado correctamente',
    deleteFieldError:'Error al eliminar el campo',
    fieldDeletedSuccessfully:'Campo eliminado correctamente (puede ser restaurado)',
    errorDeletingField:'Error al eliminar el campo',
    text: 'Texto',
    number: 'Número',
    date: 'Fecha',
    deleteFieldConfirmation:'¿Estás seguro de que quieres eliminar este campo? Esta acción no se puede deshacer.',
    deleteFieldSuccess:'Campo eliminado correctamente',
    deleteFieldSuccessError:'Error al eliminar el campo',
    errorLoadingFields: 'Error al cargar campos',
    fieldUpdatedSuccess: 'Campo actualizado correctamente',
    fieldCreatedSuccess: 'Campo creado correctamente',
    errorSavingField: 'Error al guardar campo',
    requiredField: 'Campo obligatorio',
    emailTemplate: 'Plantilla de correo',
    emailTemplateRequired: 'Seleccione una plantilla de correo para los emails de aniversario',
    noEmailTemplatesAvailable: 'No hay plantillas de correo disponibles',
    anniversaryTemplate: 'Plantilla de aniversario',
    anniversaryEmailEnabled: 'Correo de aniversario activado',
  },

  // Services
  services: {
    title: 'Servicios',
    serviceName: 'Nombre del Servicio',
    addService: 'Agregar Servicio',
    editService: 'Editar Servicio',
    deleteService: 'Eliminar Servicio',
    deactivateService: 'Desactivar Servicio',
    activateService: 'Activar Servicio',
    noServicesFound: 'No se encontraron servicios',
    createFirstService: 'Crea tu primer servicio para comenzar',
    serviceInformation: 'Información del Servicio',
    confirmDeactivate: '¿Estás seguro de que quieres desactivar el servicio',
    confirmActivate: '¿Estás seguro de que quieres activar el servicio',
    deactivateMessage: 'Este servicio ya no aparecerá en los formularios de clientes.',
    activateMessage: 'Este servicio estará disponible para los formularios de clientes.',
    servicemanagment:'Gestión de servicios',
    msgsmanagment:'Gestiona y organiza tus servicios',
    searchsv:'Servicios de búsqueda...',
    tstatus:'Estado',
    allstatus:'Estados',
    tactive:'Activo',
    tinactive:'Inactivo',
    clearfilters:'Borrar Filtros',
    sertype:'Tipo de Servicios',
    msgnmservice:'Ingrese el nombre del servicio',
    previewservice:'Vista previa del servicio',
    msgdetailsSv:'Complete los detalles del servicio a continuación',
    createNService:'Crear Nuevo Servicio',
  },

  // Service History
  serviceHistory: {
    title: 'Historial de Servicios',
    service: 'Servicio',
    client: 'Cliente',
    cost: 'Costo',
    noHistoryFound: 'No se encontró historial de servicios',
    createFirstService: 'Completa tu primer servicio para ver el historial aquí',
    msgtrack:'Seguimiento y gestión de los registros del historial de servicio',
    searchHistory:'Historial de busqueda...',
    allservice: 'Todos los Servicios',
    allclients:'Todos los clientes',
    today:'Hoy',
    tweek:"Esta Semana",
    tmonth:"Este Mes",
    clearfilters:'Borrar Filtros',
    createRecord:'Crear Registro',
    createHService:'Crear Historial de Servicio',
    msgcreateHService:'¡Historial de servicio creado correctamente!',
  },

  // Invoices
  invoices: {
    title: 'Facturas',
    invoiceNumber: 'Número de Factura',
    invoiceDate: 'Fecha de Factura',
    dueDate: 'Fecha de Vencimiento',
    amount: 'Monto',
    status: 'Estado',
    paid: 'Pagado',
    pending: 'Pendiente',
    overdue: 'Vencido',
    addInvoice: 'Agregar Factura',
    editInvoice: 'Editar Factura',
    deleteInvoice: 'Eliminar Factura',
    printInvoice: 'Imprimir Factura',
    noInvoicesFound: 'No se encontraron facturas',
    createFirstInvoice: 'Crea tu primera factura para comenzar',
    tinvoice: 'Gestión de facturas',
    msginvoice:'Gestiona y realiza el seguimiento de todas tus facturas',
    sinvoice:'Buscar facturas...',
    Cancelled:'Cancelada',
    infoinvoice:'Información de factura',
    createNewinvoice: 'Crear nueva factura',
    msginfoInvoice:'Complete la información de la factura a continuación',
    businessname:'Nombre comercial',
    businessaddress:'Dirección comercial',
    itemsinvoice:'Artículos de factura',
    summaryInvoice:'Resumen factura',
  },

  // Calendar
  calendar: {
    title: 'Calendario',
    appointments: 'Citas',
    addAppointment: 'Agregar Cita',
    editAppointment: 'Editar Cita',
    deleteAppointment: 'Eliminar Cita',
    noAppointments: 'No hay citas programadas',
    scheduleAppointment: 'Programa tu primera cita',

    pageTitle: 'Gestión de Calendario',
    pageSubtitle: 'Gestiona citas y horarios para tu clínica',
    newAppointment: 'Nueva Cita',
    configure: 'Configurar',
    refreshTooltip: 'Actualizar calendario y reservas recientes',

    legend: {
      workingDay: 'Día Laboral',
      offDay: 'Día Libre',
      partiallyBooked: 'Parcialmente Ocupado',
      fullyBooked: 'Completamente Ocupado'
    },

    days: {
      sun: 'Dom',
      mon: 'Lun',
      tue: 'Mar',
      wed: 'Mié',
      thu: 'Jue',
      fri: 'Vie',
      sat: 'Sáb'
    },

    offDay: 'Día Libre',
    availability: {
      available: 'disponible',
      booked: 'reservado'
    },
    alerts: {
      offDay: 'Este es un día libre'
    },

    availableTimeSlots: 'Horarios Disponibles',
    bookedAppointments: 'Citas Reservadas',
    secretaryQueue: 'Cola de secretaría: marca quién ya llegó y llama rápido a pacientes atrasados.',
    noAvailableTimeSlots: 'No hay horarios disponibles para este día',
    moreAppointments: 'Desplázate para ver más citas...',

    selectClientForSlot: 'Selecciona un cliente para {start} - {end}',
    client: 'Cliente',
    chooseClient: 'Elige un cliente...',
    searchClient: 'Buscar por nombre, teléfono o ID…',

    appointmentDetails: 'Detalles de la Cita',
    scheduleNewAppointment: 'Programar Nueva Cita',

    appointmentLabels: {
      unknownClient: 'Cliente Desconocido',
      appointment: 'Cita',
      unknown: 'Desconocido',
      generalAppointment: 'Cita General'
    },

    fields: {
      client: 'Cliente',
      phone: 'Teléfono',
      email: 'Correo',
      visitType: 'Tipo de Visita'
    },

    common: {
      na: 'N/D'
    },

    queue: {
      arrived: 'Llegó'
    },

    confirmation: {
      columnTitle: 'Confirmaciones',
      columnSubtitle: 'Confirma asistencia antes de marcar que el paciente ya llegó.',
      bulkSendWhatsapp: 'Enviar WhatsApp a todas',
      bulkSendingWhatsapp: 'Enviando...',
      title: 'Confirmación de cita',
      messageLabel: 'Mensaje',
      useDefault: 'Usar mensaje por defecto',
      confirmOnly: 'Confirmar',
      confirmWhatsapp: 'Recordatorio por WhatsApp',
      confirmEmail: 'Recordatorio por correo',
      emailSubject: 'Confirmación de cita',
      defaultMessage: 'Hola {patient}, tu cita está confirmada para {date} de {start} a {end}.',
      confirmedOnly: 'Cita confirmada correctamente.',
      sentToWhatsapp: 'Cita confirmada y WhatsApp abierto.',
      sentToEmail: 'Cita confirmada y cliente de correo abierto.',
      bulkWhatsappResult: 'WhatsApp masivo listo: {success} abiertos, {failed} sin teléfono.',
      phoneRequiredForWhatsapp: 'Se requiere teléfono del cliente para enviar por WhatsApp.',
      emailRequired: 'Se requiere correo del cliente para enviar confirmación.',
      errorConfirming: 'No se pudo confirmar la cita.',
      errorBulkWhatsapp: 'No se pudo completar el envío masivo de WhatsApp.',
      status: {
        confirmedOnly: 'Confirmada',
        whatsappSent: 'WhatsApp listo',
        emailSent: 'Correo listo',
        whatsappFailed: 'WhatsApp no enviado',
        emailFailed: 'Correo no enviado',
        confirmFailed: 'Confirmación fallida'
      }
    },

    linkPublic: {
      badge: 'Reserva pública',
      hint: 'Vincula esta cita al expediente correcto del paciente.',
      selectPatient: 'Paciente',
      choosePatient: 'Elegir paciente…',
      searchPatient: 'Escribe nombre, teléfono o ID…',
      suggestedMatches: 'Coincidencias sugeridas (nombre o teléfono)',
      linkButton: 'Vincular a paciente',
      linking: 'Vinculando…',
      success: 'Cita vinculada al paciente.',
      error: 'No se pudo vincular la cita. Intenta de nuevo.',
      selectPatientFirst: 'Selecciona un paciente para vincular.',
      saveAsNewClientButton: 'Guardar como cliente nuevo',
      saving: 'Guardando…',
      savedAsNewClient: 'Se creó el cliente nuevo y se vinculó a esta cita.',
      saveAsNewClientError: 'No se pudo guardar como cliente nuevo. Intenta de nuevo.',
      nameRequired: 'Esta reserva no tiene nombre para crear un cliente.'
    },

    form: {
      creating: 'Creando...',
      cancel: 'Cancelar',
      close: 'Cerrar',
      cancelAppointment: 'Cancelar cita',
      cancelConfirmTitle: '¿Cancelar cita?',
      cancelConfirmMessage:
        'Se eliminará la cita de {patient} el {date} ({time}). Esta acción no se puede deshacer.',
      cancelConfirmAction: 'Sí, cancelar cita',
      cancelAppointmentSuccess: 'Cita cancelada.',
      cancelAppointmentError: 'No se pudo cancelar la cita. Intenta de nuevo.'
    },

    settings: {
      title: 'Configuración del Calendario',
      tabs: {
        weeklySchedule: 'Horario Semanal',
        customDates: 'Fechas Personalizadas',
        publicBooking: 'Reservas públicas'
      },
      publicBookingLanguage: 'Idioma de la página pública de reservas',
      publicBookingLanguageHint:
        'Idioma que verán tus pacientes en el enlace público para agendar citas en línea.',
      languageEnglish: 'Inglés',
      languageSpanish: 'Español',
      savePublicLanguage: 'Guardar idioma',
      publicLanguageSaved: 'Idioma de reservas públicas guardado.',
      publicLanguageError: 'No se pudo guardar el idioma de reservas públicas.',
      defaultWeeklySchedule: 'Horario Semanal Predeterminado',
      weekday: 'Día de la semana',
      weekdays: {
        sunday: 'Domingo',
        monday: 'Lunes',
        tuesday: 'Martes',
        wednesday: 'Miércoles',
        thursday: 'Jueves',
        friday: 'Viernes',
        saturday: 'Sábado'
      },
      startTime: 'Hora de inicio',
      endTime: 'Hora de fin',
      status: 'Estado',
      saveSchedule: 'Guardar Horario',
      scheduleSaved: 'Horario semanal guardado.',
      scheduleError: 'No se pudo guardar el horario semanal. Revisa las horas e inténtalo de nuevo.',
      scheduleEndBeforeStart: 'La hora de fin debe ser posterior a la de inicio.',
      currentWeeklyConfig: 'Configuracion semanal actual',
      customDateOverrides: 'Excepciones por fecha',
      overrideDefaultSchedules:
        'Define el horario de un solo día. Las reservas usan este horario solo en esa fecha; el resto sigue el horario semanal.',
      overrideDate: 'Fecha',
      saveOverride: 'Guardar excepción',
      removeOverride: 'Quitar excepción',
      noOverrides: 'Aún no hay excepciones por fecha.',
      overrideSaved: 'Horario personalizado guardado para esta fecha.',
      overrideRemoved: 'Excepción eliminada. Esta fecha volverá al horario semanal.',
      overrideDateRequired: 'Selecciona una fecha.',
      overrideError: 'No se pudo guardar el horario personalizado. Inténtalo de nuevo.',
      overrideDeleteError: 'No se pudo quitar la excepción. Inténtalo de nuevo.',
      existingOverrides: 'Excepciones guardadas',
      defaultForWeekday: 'Horario semanal de referencia: {status} · {range}',
      clickToEdit: 'Clic para editar'
    },

    dialog: {
      scheduleNewAppointmentTitle: 'Programar Nueva Cita',
      clientRequired: 'Cliente *',
      dateRequired: 'Fecha *',
      startTimeRequired: 'Hora de inicio *',
      endTimeRequired: 'Hora de fin *',
      visitIdOptional: 'ID de visita (Opcional)',
      visitLinkPlaceholder: 'Enlazar a una visita existente',
      createAppointment: 'Crear Cita',
      errors: {
        fillRequiredFields: 'Por favor completa todos los campos requeridos',
        errorCreatingAppointment: 'Error al crear la cita'
      }
    },
    public: {
      openPublicView: 'Vista pública de reservas',
      title: 'Reserva tu cita',
      titleDefault: 'Reserva de citas',
      titleWithDoctor: '{name} — reserva de citas',
      subtitle: 'Elige un horario disponible y reserva tu cita.',
      tenantHint:
        'Enlace compartido: si no carga el horario, agrega ?tenantId=ID_DE_TU_CLÍNICA a la URL (tu clínica te lo proporciona).',
      selectDate: 'Seleccionar fecha',
      offDay: 'No hay reservas disponibles para este día.',
      noSlots: 'No hay horarios disponibles para este día.',
      bookThisSlot: 'Reservar este horario',
      bookDialogTitle: 'Reservar cita',
      newPatientName: 'Tu nombre',
      newPatientEmail: 'Correo electrónico',
      newPatientPhone: 'Número de teléfono',
      contactHint: 'El correo y el teléfono son opcionales pero recomendados.',
      nameRequired: 'Ingresa tu nombre.',
      saveAsNewClient: 'Crear un expediente nuevo en la clínica (opcional)',
      confirmBooking: 'Confirmar reserva',
      bookingSuccess: 'Tu cita fue reservada correctamente.',
      bookingError: 'No se pudo reservar tu cita. Inténtalo de nuevo.',
      loadError: 'No se pudo cargar el horario público.',
      networkError:
        'No se pudo conectar con el servidor (red/CORS). Verifica que la API esté en marcha (p. ej. puerto 8080), reinicia Laravel tras cambios de CORS y recarga la página.'
    }
  },

  cleaningSchedule: {
    title: 'Cronograma',
    client: 'Cliente',
    day: 'Día',
    week: 'Semana',
    month: 'Mes',
    today: 'Hoy',
    timeTeam: 'Hora / equipo',
    filterClient: 'Cliente',
    filterCleaner: 'Personal',
    all: 'Todos',
    dailyCapacity: 'Capacidad diaria',
    capacityWarning: 'Cerca del máximo de capacidad',
    capacityFull: 'Capacidad casi llena',
    unassigned: 'Trabajos sin asignar',
    unassignedWeekHint: 'Todos los huecos abiertos de esta semana (cualquier día).',
    noneUnassigned: 'No hay trabajos sin asignar esta semana.',
    slots: 'cupos',
    autoSchedule: 'Auto-programar restantes',
    assignWho: 'Asignar a…',
    assignMultipleTitle: 'Asignar personal',
    assignMultipleHint: 'Selecciona uno o más empleados para este trabajo en esta fecha.',
    assignAddCleanerTitle: 'Añadir otra persona',
    assignAddCleanerHint:
      'Solo aparecen quienes aún no están en este trabajo ese día. Toca los nombres para seleccionar y guarda.',
    assignAddCleanerTooltip: 'Añadir personal',
    assignAddNoOneAvailable:
      'No hay más personas disponibles (ya están todos asignados ese día o el filtro lo limita).',
    shiftTeamHint:
      'Solo quita la asignación en el calendario para ese día (el trabajo de limpieza no se elimina).',
    shiftRemoveOne: 'Quitar de este día',
    cardDialogTypeProjected: 'En el equipo — sin cita en el calendario',
    cardDialogTypeScheduled: 'Programado',
    cardDialogCleanersSection: 'En este turno',
    cardDialogAddCleaner: 'Añadir otra persona',
    cardDialogUnassignedHelp:
      'Esta visita aún necesita asignación para este día. Elige quién la realiza.',
    cardDialogProjectedHelp:
      '{name} está vinculado a este trabajo pero aún no tiene asignación en el calendario para este día.',
    cardDialogPlaceOnCalendar: 'Poner en el calendario este día',
    cardDialogProjectedAddCleanerHint:
      'Usa el botón de arriba para poner a “{name}” en el calendario. Para programar a otra persona en este trabajo este día, usa Añadir otra persona.',
    cardDialogLinkedCleanerFallback: 'la persona vinculada',
    cardDialogAssign: 'Asignar personal',
    cardDialogEditJob: 'Abrir trabajo para editar detalles',
    cardDialogTotalHours: 'Horas totales (trabajo): {hours} h',
    cardDialogHoursPerPerson:
      'Cada persona en sitio ~{each} h ({total} h trabajo ÷ {count} personas).',
    cardDialogFullWindow: 'Ventana completa del trabajo en el calendario: {start}–{end}',
    fullJobWindowNote: 'Visita completa hasta {end}',
    tooltipScheduledMulti:
      '{client} · Cada uno en sitio {eachStart}–{eachEnd} ({each} h, {count} personas) · Reserva hasta {jobEnd}',
    assignSave: 'Asignar seleccionados',
    assignPickOne: 'Selecciona al menos un empleado.',
    assignScopeTitle: '¿Cómo debe aplicarse esta asignación?',
    assignScopeDescription:
      'Este trabajo se repite. Puedes sumar a esta persona al equipo del trabajo para las próximas visitas (aparecerá en fechas posteriores), o asignarla solo para esta visita sin formar parte del equipo permanente en otras fechas.',
    assignScopeDescriptionOneOff:
      'Esta visita es un trabajo de un solo día (no hay serie recurrente). Confirma para añadir la asignación en el calendario solo para esta fecha.',
    assignScopeWholeSeries: 'Toda la serie — equipo del trabajo',
    assignScopeThisVisit: 'Solo esta visita',
    assignScopeConfirmOneOff: 'Asignar para esta fecha',
    recurringConflictTitle: 'Posibles conflictos en fechas futuras',
    recurringConflictIntro:
      'Al añadir a esta persona a toda la serie, se espera en cada ocurrencia futura de este trabajo. Ya tiene asignaciones que se cruzan con otras visitas en las fechas siguientes.',
    recurringConflictThisJobWindow: 'Horario de este trabajo: {start}–{end}',
    recurringConflictOtherJob: 'Otro trabajo: {client} ({start}–{end})',
    recurringConflictGoBack: 'Volver',
    recurringConflictAssignAnyway: 'Asignar a toda la serie de todos modos',
    recurringConflictPreviewError: 'No se pudo comprobar conflictos futuros. Inténtalo de nuevo o elige “Solo esta visita”.',
    selected: 'Seleccionado',
    tapToSelect: 'Toca',
    assignedPartial: 'Asignados {ok}, fallidos {fail}',
    loadError: 'No se pudo cargar el cronograma',
    assigned: 'Asignación guardada',
    assignError: 'No se pudo crear la asignación',
    removed: 'Asignación eliminada',
    removeError: 'No se pudo eliminar la asignación',
    add: 'Agregar',
    addOnDemandForClient: 'Agregar trabajo bajo demanda para el cliente seleccionado',
    addNewClientOnDemand: 'Agregar nuevo cliente + trabajo bajo demanda',
    onDemandTitle: 'Crear trabajo bajo demanda',
    onDemandInfo:
      'Se creará como un horario de un solo día para que aparezca en este calendario (no se repetirá).',
    onDemandFillRequired: 'Selecciona cliente, fecha, horas y tarifa por hora.',
    onDemandCreated: 'Trabajo bajo demanda creado',
    onDemandCreateError: 'No se pudo crear el trabajo bajo demanda',
    serviceDate: 'Fecha del servicio',
    startTime: 'Hora de inicio',
    hours: 'Horas',
    hourlyRate: 'Tarifa por hora',
    wages: 'Salarios',
    notes: 'Notas',
    availableCleaners: 'Personal disponible',
    availableCleanersHint: 'No está programado en el día seleccionado.',
    noneAvailable: 'No hay personal disponible para este día.',
    dailyCapacityHint:
      'La capacidad usa las horas semanales (ajustes) cuando existen; si no, el “máx. horas por día” del empleado.',
    cleanersHoursHint: 'Muestra a todos los empleados activos y cuántas horas tienen asignadas el día seleccionado.',
    assignedHoursLabel: 'Horas asignadas hoy: {hours} h',
    totalAssignedHoursLabel: 'Horas de trabajo del día: {hours} h',
    dayPendingTooltip: 'Este día tiene trabajos sin asignar o visitas que requieren atención.',
    dayPendingAria: 'Pendientes en este día',
    offFullDayLabel: 'No disponible (día completo fuera)',
    attentionWeekCount: '{count} visita(s) requieren atención',
    attentionDayTitle: 'Requiere atención hoy',
    attentionDayHint: 'El personal tiene el día libre o no está disponible en parte del horario del trabajo.',
    attentionTooltip: 'Requiere atención (ausencia)',
    availabilityDialogTitle: 'Capacidad del calendario y ausencias',
    availabilityDialogTooltip: 'Horas semanales y días libres',
    availabilityDialogIntro:
      'Define horas disponibles por día de la semana (capacidad del equipo). Registra ausencias para resaltar trabajos que chocan con ese tiempo.',
    availabilityTabWeekly: 'Horas semanales',
    availabilityTabTimeOff: 'Ausencias',
    availabilityPickEmployee: 'Empleado',
    availabilityDow1: 'Lunes (horas)',
    availabilityDow2: 'Martes (horas)',
    availabilityDow3: 'Miércoles (horas)',
    availabilityDow4: 'Jueves (horas)',
    availabilityDow5: 'Viernes (horas)',
    availabilityDow6: 'Sábado (horas)',
    availabilityDow7: 'Domingo (horas)',
    availabilitySaveWeekly: 'Guardar horas semanales',
    availabilityWeeklySaved: 'Disponibilidad semanal guardada',
    availabilityTimeOffHint:
      'Las ausencias son por empresa. Los trabajos que se traslapen se marcan y aparecen en “Requiere atención”.',
    availabilityTimeOffListTitle: 'Esta semana',
    availabilityTimeOffEmpty: 'No hay ausencias esta semana.',
    availabilityAddTimeOffSection: 'Agregar ausencia',
    availabilitySubmitTimeOff: 'Guardar ausencia',
    availabilityFullDay: 'Todo el día',
    availabilityTimeStart: 'Desde',
    availabilityTimeEnd: 'Hasta',
    availabilityReason: 'Motivo (opcional)',
    availabilityTimeOffAdded: 'Ausencia guardada',
    availabilityTimeOffRemoved: 'Ausencia eliminada',
    availabilityLoadError: 'No se pudieron cargar los ajustes de disponibilidad',
    noneActiveCleaners: 'No hay empleados activos.',
  },

  cleaningDetails: {
    title: 'Trabajos de limpieza',
    new: 'Nuevo trabajo',
    edit: 'Editar trabajo',
    client: 'Cliente',
    addClient: 'Agregar cliente',
    addClientTitle: 'Nuevo cliente',
    clientName: 'Nombre',
    clientPhone: 'Teléfono',
    clientEmail: 'Correo',
    clientNameRequired: 'El nombre del cliente es requerido.',
    clientCreated: 'Cliente creado',
    clientCreateError: 'No se pudo crear el cliente',
    recurrence: 'Horario',
    recurrenceOptional: 'Horario (opcional)',
    recurrenceFieldHelp:
      'Asocia una regla repetida (p. ej. Cada N semanas + fecha de inicio + hora), o deja Bajo demanda y programa las visitas manualmente en el calendario.',
    onDemandNoSchedule: 'Bajo demanda (sin horario recurrente)',
    schedule: 'Horario',
    newSchedule: 'Nuevo horario',
    createSchedule: 'Crear horario',
    copyDefaultsFromScheduled: 'Copiar horas/tarifa desde un trabajo programado',
    copiedDefaults: 'Valores copiados (guardado como bajo demanda)',
    noScheduledDefaults: 'No se encontró un trabajo programado para este cliente.',
    copyDefaultsError: 'No se pudieron copiar los valores',
    scheduleType: 'Repetición',
    daily: 'Diario',
    weekly: 'Semanal',
    everyNWeeks: 'Cada N semanas (día de la semana)',
    monthly: 'Mensual',
    everyWeeksInterval: 'Cada (semanas)',
    everyNWeeksHelp:
      'Mismo día de la semana cada N semanas. Empieza el primer día coincidente en o después de la fecha de inicio (0 = dom … 6 = sáb).',
    scheduleEveryNWeeks: 'Cada {n} semanas',
    everyDays: 'Cada (días)',
    dayOfWeek: 'Día de la semana (0 dom – 6 sáb)',
    dayOfWeekHelp: '0 = domingo, 1 = lunes, … 6 = sábado',
    dayOfMonth: 'Día del mes',
    startDate: 'Fecha inicio',
    endDate: 'Fecha fin (opcional)',
    startTime: 'Hora inicio',
    notes: 'Notas',
    horas: 'Horas',
    hourlyRate: 'Tarifa por hora',
    income: 'Ingreso',
    wages: 'Salarios',
    team: 'Equipo',
    cleaners: 'Personal (equipo)',
    addCleaners: 'Añadir personal',
    cleanersDialogTitle: 'Añadir personas a este trabajo',
    cleanersSearchPlaceholder: 'Buscar por nombre…',
    cleanersPickerEmpty: 'No hay empleados que coincidan o ya están todos en el equipo.',
    cleanersPlaceholder: 'Busca y añade varias personas',
    totalHoursHelper: 'Tiempo total en sitio para este trabajo (facturación y planificación).',
    openSchedule: 'Abrir horario de limpieza',
    scheduleHint:
      'Este formulario define el trabajo (cliente, horas, equipo, montos). Usa el horario de limpieza para añadir cada visita (día, hora, personal).',
    cleanersHelper:
      'Selecciona uno o más empleados para este trabajo. Quitar a alguien aquí elimina sus asignaciones en el calendario para este trabajo (se borran los registros vinculados a ese empleado).',
    actions: 'Acciones',
    none: 'Aún no hay trabajos de limpieza.',
    filteredByClient: 'Filtrado por cliente',
    deleteTitle: 'Eliminar trabajo',
    deleteConfirm: '¿Eliminar este trabajo? Puede afectar asignaciones relacionadas.',
    loadError: 'No se pudieron cargar los trabajos',
    saveError: 'No se pudo guardar',
    createdSuccess: 'Trabajo creado',
    updatedSuccess: 'Trabajo actualizado',
    deletedSuccess: 'Trabajo eliminado',
    deleteError: 'No se pudo eliminar',
    recurrenceCreated: 'Horario creado',
    recurrenceError: 'No se pudo crear el horario',
    selectSchedulePlaceholder: 'Selecciona un horario…',
    selectScheduleRequired:
      'Elige un horario en la lista o usa "+ Nuevo horario" para crear uno. Horas y tarifa no bastan sin un horario.',
    fillRequired: 'Selecciona un cliente e ingresa horas y tarifa por hora.',
  },

  // Forms
  forms: {
    required: 'Este campo es requerido',
    invalidEmail: 'Por favor ingresa un correo válido',
    invalidPhone: 'Por favor ingresa un teléfono válido',
    minLength: 'Debe tener al menos {min} caracteres',
    maxLength: 'No debe tener más de {max} caracteres',
    invalidDate: 'Por favor ingresa una fecha válida',
    invalidTime: 'Por favor ingresa una hora válida',
    invalidNumber: 'Por favor ingresa un número válido',
    invalidUrl: 'Por favor ingresa una URL válida',
    passwordsDoNotMatch: 'Las contraseñas no coinciden',
    weakPassword: 'La contraseña debe tener al menos 8 caracteres'
  },

  // Messages
  messages: {
    saveSuccess: 'Guardado exitosamente',
    updateSuccess: 'Actualizado exitosamente',
    deleteSuccess: 'Eliminado exitosamente',
    createSuccess: 'Creado exitosamente',
    saveError: 'Error al guardar',
    updateError: 'Error al actualizar',
    deleteError: 'Error al eliminar',
    createError: 'Error al crear',
    loadError: 'Error al cargar datos',
    networkError: 'Error de red. Por favor verifica tu conexión.',
    unauthorized: 'No estás autorizado para realizar esta acción',
    notFound: 'El recurso solicitado no fue encontrado',
    serverError: 'Error del servidor. Por favor intenta más tarde.',
    validationError: 'Por favor revisa el formulario para errores'
  },

  // Inventario y Ventas
  inventory: {
    origin: {
      customer: 'Cliente',
      supplier: 'Proveedor',
      other: 'Otro'
    }
  },
  sales: {
    title: 'Ventas',
    newSale: 'Nueva Venta',
    editSale: 'Editar Venta',
    customer: 'Cliente',
    noCustomer: 'Sin Cliente',
    originCustomer: 'Cliente',
    search: 'Buscar...',
    product: 'Producto',
    allProducts: 'Todos los Productos',
    client: 'Cliente',
    allClients: 'Todos los Clientes',
    location: 'Bodega',
    allLocations: 'Todas las Bodegas',
    date: 'Fecha',
    quantity: 'Cantidad',
    unitPrice: 'Precio Unitario',
    total: 'Total',
    notes: 'Notas',
    actions: 'Acciones',
    noSalesFound: 'No se encontraron ventas',
    date: 'Fecha',
    additionalNotes: 'Notas adicionales sobre esta venta',
    totalSaleAmount: 'Total de la Venta',
    errorLoadingSales: 'Error al cargar ventas',
    saleDeletedSuccess: 'Venta eliminada correctamente y entrada de kardex eliminada',
    errorDeletingSale: 'Error al eliminar venta',
    errorLoadingSale: 'Error al cargar venta',
    pleaseSelectLocation: 'Por favor selecciona una bodega',
    pleaseAddProduct: 'Por favor agrega al menos un producto a la venta',
    saleRegisteredSuccess: 'Venta registrada correctamente con {count} artículo(s)',
  },

  // Gestión de Inquilinos
  tenantManagement: {
    title: 'Gestión de Inquilinos',
    createTenant: 'Crear Inquilino',
    editTenant: 'Editar Inquilino',
    createTenantDescription: 'Crear un nuevo inquilino (empresa) para Techno multi-inquilino.',
    editTenantDescription: 'Editar información y configuraciones del inquilino.',
    companyName: 'Nombre de la Empresa',
    subdomain: 'Subdominio',
    customDomain: 'Dominio Personalizado',
    nit: 'NIT (ID Fiscal)',
    address: 'Dirección',
    plan: 'Plan',
    status: 'Estado',
    createdAt: 'Fecha de Creación',
    noTenants: 'No se encontraron inquilinos',
    searchPlaceholder: 'Buscar inquilinos...',
    filterByStatus: 'Filtrar por Estado',
    filterByPlan: 'Filtrar por Plan',
    allStatuses: 'Todos los Estados',
    allPlans: 'Todos los Planes',
    basic: 'Básico',
    professional: 'Profesional',
    enterprise: 'Empresarial',
    profile: 'Perfil',
    profileDefault: 'Predeterminado',
    profileSchool: 'Escuela',
    profileLoyalty: 'Programa de lealtad',
    profileMenu: 'Menú digital',
    active: 'Activo',
    trial: 'Prueba',
    suspended: 'Suspendido',
    cancelled: 'Cancelado',
    suspend: 'Suspender',
    activate: 'Activar',
    visit: 'Visitar',
    stats: 'Estadísticas',
    usersCount: 'Usuarios',
    clientsCount: 'Clientes',
    budgetsCount: 'Presupuestos',
    servicesCount: 'Servicios',
    visitsCount: 'Visitas',
    appointmentsCount: 'Citas',
    invoicesCount: 'Facturas',
    storageUsed: 'Almacenamiento Usado',
    lastActivity: 'Última Actividad',
    email: 'Correo Electrónico',
    phone: 'Teléfono',
    subdomainHint: 'Solo letras minúsculas, números y guiones',
    customDomainHint: 'Tu dominio personalizado (ej: techno.miempresa.com)',
    invalidSubdomain: 'Formato de subdominio inválido. Usa solo letras minúsculas, números y guiones.',
    tenantCreatedSuccess: 'Tenant creado exitosamente',
    errorCreatingTenant: 'Error al crear tenant',
    tenantUpdatedSuccess: 'Tenant actualizado exitosamente',
    errorUpdatingTenant: 'Error al actualizar tenant',
    tenantSuspendedSuccess: 'Tenant suspendido exitosamente',
    errorSuspendingTenant: 'Error al suspender tenant',
    tenantActivatedSuccess: 'Tenant activado exitosamente',
    errorActivatingTenant: 'Error al activar tenant',
    errorLoadingTenants: 'Error al cargar tenants',
  },

  tenantRoles: {
    title: 'Roles por Tenant',
    description: 'Selecciona qué roles puede asignar cada tenant a sus usuarios. Al crear usuarios para un tenant, solo aparecerán estos roles.',
    selectTenant: 'Seleccionar tenant',
    rolesForTenant: 'Roles para este tenant',
    rolesHint: 'Marca los roles que este tenant puede asignar a sus usuarios.',
    assigned: 'Asignado',
    savedSuccess: 'Roles del tenant guardados correctamente',
    errorLoading: 'Error al cargar datos',
    errorLoadingRoles: 'Error al cargar roles del tenant',
    errorSaving: 'Error al guardar roles del tenant',
    noTenants: 'No hay tenants. Crea un tenant primero.',
  },

  // Budgets
   budgets: {
    title: 'Presupuestos',
    totalbudgets: 'Presupuesto total',
    draft: 'Borrador',
    approved: 'Aprobado',
    totalValue:'Valor Total',
    newBudget: 'Nuevo Presupuesto',
    srBudget:'Buscar Presupuestos...',
    all:'Todos',
    sent:'Enviado',
    rejected:'Rechazado',
    msgnobudgetfound:'No se encontraron presupuestos',
    deletebudget:'Eliminar Presupuesto',
    msgdeletebudget:'¿Estás segura de que quieres eliminar este presupuesto?',
    editBudget: 'Editar Presupuesto',
    nameBudget:'Nombre del presupuesto',
    valid:'Valido hasta',
    description:'Descripción',
    BudgetItems:'Artículos presupuestarios',
    quantity:'Cantidad',
    unit:'Unidad',
    unitPrice:'Precio Unitario',
    selectUnit:'Seleccionar unidad',
    view: 'Ver',
    edit: 'Editar',
   send: 'Enviar',
   sendNow: 'Enviar ahora',
   sendLabel: 'Enviar',
   emailRecipients: 'Destinatarios de correo',
   recipientName: 'Nombre del destinatario {n}',
   recipientEmail: 'Correo del destinatario {n}',
   approvedOn: 'Aprobado el',
   noClient: 'Sin cliente',
   sendToClient: 'Enviar al cliente ({email})',
   sendBudgetViaEmail: 'Enviar presupuesto por correo',
    sendDialogDescription: 'Selecciona o agrega las direcciones de correo que recibirán este presupuesto.',
    emailNumber: 'Correo {n}',
    emailPlaceholder: 'correo@ejemplo.com',
    remove: 'Quitar',
    addRecipient: 'Agregar destinatario',
    messageOptional: 'Mensaje (opcional)',
    emailTemplateHint: 'El correo ya incluye un saludo (Hola,) y un cierre (Gracias.). Tu mensaje aparecerá entre ellos.',
    storeNewEmails: 'Guardar correos para uso futuro',
    updateStatusToSent: 'Actualizar estado a Enviado',
   exportPdf: 'Exportar PDF',
   exportExcel: 'Exportar Excel',
   budgetUnits: 'Unidades de Presupuesto',
   manageUnits: 'Gestiona las unidades de medida disponibles para presupuestos. Solo aparecen aquí las unidades activas.',
   refresh: 'Actualizar',
   newUnit: 'Nueva Unidad',
   editBudgetUnit: 'Editar Unidad de Presupuesto',
   newBudgetUnit: 'Nueva Unidad de Presupuesto',
   active: 'Activo',
   saving: 'Guardando...',
   nameRequired: 'El nombre es requerido',
   budgetUnitUpdated: 'Unidad de presupuesto actualizada',
   budgetUnitCreated: 'Unidad de presupuesto creada',
   budgetUnitInactive: 'Unidad de presupuesto establecida como inactiva',
   errorLoadingUnits: 'Error al cargar unidades de presupuesto',
   errorSavingUnit: 'Error al guardar unidad de presupuesto',
   errorUpdatingUnit: 'Error al actualizar unidad de presupuesto',
   noActiveUnits: 'No se encontraron unidades de presupuesto activas.',
   markInactive: 'Marcar como Inactivo',
   setInactiveConfirm: '¿Establecer "{name}" como inactivo?',
   budgetTypes: 'Tipos de Presupuesto',
   manageTypes: 'Gestiona los tipos de presupuesto disponibles. Solo aparecen aquí los tipos activos.',
   newType: 'Nuevo Tipo',
   addNewType: 'Agregar nuevo tipo...',
   addNewUnit: 'Agregar nueva unidad...',
   editBudgetType: 'Editar Tipo de Presupuesto',
   newBudgetType: 'Nuevo Tipo de Presupuesto',
   budgetTypeUpdated: 'Tipo de presupuesto actualizado',
   budgetTypeCreated: 'Tipo de presupuesto creado',
   budgetTypeInactive: 'Tipo de presupuesto establecido como inactivo',
   errorLoadingTypes: 'Error al cargar tipos de presupuesto',
   errorSavingType: 'Error al guardar tipo de presupuesto',
   errorUpdatingType: 'Error al actualizar tipo de presupuesto',
   noActiveTypes: 'No se encontraron tipos de presupuesto activos.',
   errorLoadingBudgets: 'Error al cargar presupuestos',
   budgetDeletedSuccess: 'Presupuesto eliminado correctamente',
   errorDeletingBudget: 'Error al eliminar presupuesto',
   exportedSuccess: '{type} exportado correctamente',
   errorExporting: 'Error al exportar {type}',
   pleaseProvideEmail: 'Por favor proporciona al menos una dirección de correo',
   budgetSentSuccess: 'Presupuesto enviado correctamente',
   errorSendingBudget: 'Error al enviar presupuesto',
   errorLoadingBudgetTypes: 'Error al cargar tipos de presupuesto',
   errorLoadingBudgetUnits: 'Error al cargar unidades de presupuesto',
   errorLoadingClients: 'Error al cargar clientes',
   errorLoadingBudget: 'Error al cargar presupuesto',
   budgetMustHaveItem: 'El presupuesto debe tener al menos un artículo',
   pleaseFillAllItemFields: 'Por favor completa todos los campos requeridos en todos los artículos',
   budgetUpdatedSuccess: 'Presupuesto actualizado correctamente',
   budgetCreatedSuccess: 'Presupuesto creado correctamente',
  },
   // Products
 products: {
  title: 'Productos',
  newProduct: 'Producto Nuevo',
  editProduct: 'Editar Producto',
  deleteProduct: 'Eliminar Producto',
  noProductsFound: 'No se encontraron productos',
  createFirstProduct: 'Crea tu primer producto para comenzar',
  productInformation: 'Información del Producto',
  confirmDeletion: '¿Estás seguro de que quieres eliminar este producto?',
  searchProducts: 'Buscar productos...',
  image: 'Imagen',
  name: 'Nombre',
  price: 'Precio',
  actions: 'Acciones',
  productName: 'Nombre del Producto',
  ProductImage: 'Imagen del Producto',
  PriceHelperText: 'Ingrese el precio con hasta 2 decimales',
  imageHelperText: 'Recomendado: 800x800px o 1024x1024px (formato cuadrado)',
  imageDimensionsTooltip: 'Para mejores resultados, use imágenes cuadradas (proporción 1:1) con dimensiones entre 800x800px y 1024x1024px. Tamaño máximo de archivo: 10MB.',
  deleteProductConfirmation:'¿Estás seguro de que quieres eliminar este producto? Esta acción no se puede deshacer.',
  deleteProductSuccess:'Producto eliminado correctamente',
  deleteProductSuccessError:'Error al eliminar el producto',
  productDeletedSuccessfully:'Producto eliminado correctamente (puede ser restaurado)',
  errorDeletingProduct:'Error al eliminar el producto',
  Tracking:'Seguimiento',
  errorLoadingProducts: 'Error al cargar productos',
  productDeletedSuccess: 'Producto eliminado correctamente',
  errorDeletingProductSnackbar: 'Error al eliminar producto',
  errorLoadingProduct: 'Error al cargar producto',
  pleaseFillRequiredFields: 'Por favor completa todos los campos requeridos',
  pleaseEnterValidPrice: 'Por favor ingresa un precio válido',
  productUpdatedSuccess: 'Producto actualizado correctamente',
  productCreatedSuccess: 'Producto creado correctamente',
 },
  // Locations
   // Programa de lealtad
  menus: {
    dash: {
      pickMenu: 'Menú',
      editMenu: 'Editar menú',
      errorLoading: 'No se pudo cargar tu menú',
      ordersToday: 'Pedidos de hoy',
      soldToday: 'Vendido hoy',
      visits: 'Visitas al menú',
      visitsHint: 'Desde el inicio',
      pendingTitle: 'Pedidos por confirmar',
      noPending: 'No hay pedidos en espera. Los nuevos aparecen aquí solos.',
      morePending: '{count} más en Todos los pedidos',
      allOrders: 'Todos los pedidos',
      topToday: 'Lo más vendido hoy',
      noSalesToday: 'Aún no hay pedidos confirmados hoy.',
      availabilityTitle: 'Platillos del menú',
      soldOutCount: '{count} agotados',
      noDishes: 'Aún no hay platillos. Agrégalos desde Editar menú.',
    },
    title: 'Menú digital',
    subtitle: 'Crea el menú de tu restaurante y compártelo con un enlace o código QR.',
    newMenu: 'Nuevo menú',
    create: 'Crear menú',
    restaurantName: 'Nombre del restaurante',
    restaurantNameHint: 'Así aparecerá en el menú. Puedes cambiarlo después.',
    emptyTitle: 'Tu primer menú digital',
    emptyHint: 'Agrega secciones, platillos con fotos y precios, y comparte un enlace que tus clientes abren desde el celular.',
    published: 'Publicado',
    draft: 'Borrador',
    dishCount: '{count} platillos',
    sectionCount: '{count} secciones',
    views: '{count} visitas',
    copyLink: 'Copiar enlace',
    copy: 'Copiar',
    linkCopied: 'Enlace copiado',
    linkUpdated: 'Enlace actualizado',
    openMenu: 'Ver menú',
    preview: 'Vista previa',
    openPreview: 'Abrir vista previa',
    notPublishedYet: 'Publica el menú para abrir el enlace',
    backToMenus: 'Volver a menús',
    draftHint: 'Este menú es un borrador: solo tú puedes verlo con la vista previa. Actívalo con el interruptor "Publicado" cuando esté listo.',
    draftHintReadOnly: 'Este menú aún no está publicado.',
    nowPublished: '¡Menú publicado! Ya puedes compartir el enlace.',
    nowUnpublished: 'Menú despublicado: el enlace ya no está disponible.',
    tabDishes: 'Platillos',
    tabDesign: 'Diseño',
    tabInfo: 'Información',
    tabShare: 'Compartir',
    tabOrders: 'Pedidos',
    pendingBeforeOne: 'Hay 1 pedido por confirmar de días anteriores.',
    pendingBefore: 'Hay {count} pedidos por confirmar de días anteriores.',
    showPending: 'Ver',
    pendingOrdersCount: '{count} por confirmar',
    errorLoadingOrders: 'No se pudieron cargar los pedidos',
    ordersOffHint: 'Los pedidos llegan cuando el cliente toca "Pedir por WhatsApp". Activa los pedidos por WhatsApp en Información para recibirlos.',
    range: { today: 'Hoy', yesterday: 'Ayer', week: '7 días', month: '30 días', custom: 'Personalizado' },
    rangeFrom: 'Desde',
    rangeTo: 'Hasta',
    refresh: 'Actualizar',
    statOrders: 'Pedidos',
    statSold: 'Vendido',
    statSoldHint: '{count} confirmados · ticket promedio {avg}',
    orderStatus: { pending: 'Por confirmar', confirmed: 'Confirmado', cancelled: 'Cancelado' },
    allStatuses: 'Todos',
    viewOrders: 'Pedidos',
    viewProducts: 'Productos vendidos',
    customer: 'Cliente',
    orderNumber: 'Pedido',
    orderTime: 'Fecha',
    orderItems: 'Platillos',
    orderTotal: 'Total',
    status: 'Estado',
    orderDetail: 'Ver detalle',
    confirmOrder: 'Confirmar',
    cancelOrder: 'Cancelar',
    cancelOrderConfirm: '¿Cancelar el pedido #{number}?',
    confirmedBy: 'Confirmado por {name} · {time}',
    cancelledBy: 'Cancelado por {name} · {time}',
    noOrders: 'No hay pedidos en estas fechas.',
    product: 'Producto',
    quantity: 'Cant.',
    unitPrice: 'Precio',
    amount: 'Monto',
    timesSold: 'Vendidos',
    inOrders: 'Pedidos',
    productsHint: 'Solo cuenta pedidos confirmados.',
    noProductsSold: 'Aún no hay ventas confirmadas en estas fechas.',
    rowsPerPage: 'Por página',
    livePreview: 'Vista en celular',
    errorLoading: 'No se pudo cargar el menú',
    errorSaving: 'No se pudieron guardar los cambios',
    saved: 'Cambios guardados',
    deleted: 'Eliminado',
    unsavedChanges: 'Tienes cambios sin guardar',
    allSaved: 'Todo guardado',
    discard: 'Descartar',
    saveChanges: 'Guardar cambios',

    // Sections & dishes
    newSection: 'Nueva sección',
    editSection: 'Editar sección',
    deleteSection: 'Eliminar sección',
    sectionName: 'Nombre de la sección',
    sectionNamePlaceholder: 'Entradas, Platos fuertes, Bebidas…',
    sectionDescription: 'Nota de la sección (opcional)',
    sectionDescriptionPlaceholder: 'Servido hasta las 11:30, incluye bebida…',
    sectionEmpty: 'Aún no hay platillos en esta sección.',
    noSectionsTitle: 'Empieza por una sección',
    noSectionsHint: 'Organiza tu menú en secciones como Desayunos, Platos fuertes o Bebidas, y luego agrega los platillos.',
    deleteSectionConfirm: '¿Eliminar "{name}" y sus {count} platillos?',
    hideSection: 'Ocultar sección del menú',
    showSection: 'Mostrar sección en el menú',
    hidden: 'Oculto',
    dragToReorder: 'Arrastra para reordenar',
    addDish: 'Agregar platillo',
    newDish: 'Nuevo platillo',
    editDish: 'Editar platillo',
    deleteDish: 'Eliminar platillo',
    deleteDishConfirm: '¿Eliminar "{name}"?',
    dishName: 'Nombre del platillo',
    dishDescription: 'Descripción',
    dishDescriptionHint: 'Ingredientes, acompañamientos, tamaño de la porción…',
    section: 'Sección',
    priceSingle: 'Un precio',
    priceOptions: 'Tamaños / opciones',
    price: 'Precio',
    priceHint: 'Déjalo vacío si el precio es a consultar.',
    optionLabel: 'Opción',
    addOption: 'Agregar opción',
    removeOption: 'Quitar opción',
    sizeSmall: 'Pequeño',
    sizeLarge: 'Grande',
    from: 'desde',
    tags: 'Etiquetas',
    tag: {
      popular: 'Favorito',
      new: 'Nuevo',
      chef: 'Del chef',
      spicy: 'Picante',
      vegetarian: 'Vegetariano',
      vegan: 'Vegano',
      gluten_free: 'Sin gluten',
    },
    dishPhotoHint: 'Una buena foto vende más · cuadrada u horizontal',
    available: 'Disponible',
    availableShort: 'Disponible',
    availableHint: 'Apágalo cuando se acabe: aparece como "Agotado".',
    soldOut: 'Agotado',
    markSoldOut: 'Marcar como agotado',
    markAvailable: 'Marcar como disponible',
    nowSoldOut: '{name}: agotado',
    nowAvailable: '{name}: disponible',
    featured: 'Destacado',
    featuredHint: 'Se muestra con la foto en grande.',
    visible: 'Visible en el menú',
    visibleHint: 'Apágalo para ocultarlo sin borrarlo.',

    // Design
    photos: 'Fotos',
    photosHint: 'La portada acompaña a tus clientes mientras leen el menú.',
    cover: 'Portada',
    coverHint: 'Foto vertical de tu local o platillo estrella',
    logo: 'Logo',
    logoHint: 'PNG con fondo transparente',
    color: 'Color de la marca',
    colorHint: 'Se usa en el toldo de rayas, los botones y la selección del cliente.',
    customColor: 'Color',
    style: 'Estilo',
    theme: 'Fondo',
    themeLight: 'Claro',
    themeDark: 'Oscuro',
    font: 'Tipografía',
    font_slab: 'Clásica',
    font_slab_hint: 'Cálida y legible, de fonda y cafetería.',
    font_serif: 'Elegante',
    font_serif_hint: 'Para restaurantes y bistrós.',
    font_sans: 'Moderna',
    font_sans_hint: 'Limpia, para cafés y comida rápida.',
    imageAdd: 'Agregar foto',
    imageHint: 'PNG, JPG o WebP',
    imageReplace: 'Cambiar',
    imageRemove: 'Quitar foto',
    imageInvalid: 'Elige un archivo de imagen.',
    imageTooLarge: 'La imagen es demasiado grande (máx. 12 MB).',

    // Info
    restaurant: 'Restaurante',
    tagline: 'Frase corta',
    taglinePlaceholder: 'Cocina chapina de leña desde 1998',
    about: 'Nuestra historia',
    aboutPlaceholder: 'Cuéntales a tus clientes quiénes son…',
    aboutHint: 'Deja una línea en blanco entre párrafos.',
    contact: 'Contacto y ubicación',
    phone: 'Teléfono',
    whatsappHint: 'Número con código de país si no es de Guatemala.',
    whatsappOrders: 'Recibir pedidos por WhatsApp',
    whatsappOrdersHint: 'Tus clientes arman su selección en el menú y te la envían por WhatsApp.',
    email: 'Correo',
    address: 'Dirección',
    mapsUrl: 'Enlace de Google Maps (opcional)',
    mapsUrlHint: 'Si lo dejas vacío, se busca la dirección en Google Maps.',
    hours: 'Horario',
    hoursPlaceholder: 'Martes a domingo\n7:00 – 22:00',
    social: 'Redes sociales',
    website: 'Sitio web',

    // Share
    publicLink: 'Enlace público',
    publicLinkHint: 'Compártelo en redes, WhatsApp o Google. No requiere iniciar sesión.',
    slug: 'Personalizar enlace',
    slugHint: 'Solo minúsculas, números y guiones.',
    slugWarning: 'Si cambias el enlace, los códigos QR ya impresos dejarán de funcionar.',
    qrTitle: 'Código QR',
    qrHint: 'Para mesas, mostrador o la puerta.',
    downloadQr: 'Descargar',
    printCard: 'Imprimir tarjeta',
    printScan: 'Escanea para ver nuestro menú',
    deleteMenu: 'Eliminar menú',
    deleteMenuHint: 'Se borran todas las secciones, platillos y fotos. El enlace y el QR dejan de funcionar.',
    deleteMenuConfirm: '¿Eliminar el menú "{name}"? Esta acción no se puede deshacer.',
  },
  loyalty: {
    cashierTitle: 'Caja de lealtad',
    dashboardTitle: 'Programa de lealtad',
    findCustomer: 'Buscar cliente',
    scanOrSearch: 'Escanear QR o ingresar teléfono',
    scanPlaceholder: 'Código QR o número de teléfono',
    scanHint: 'Escanea el QR del cliente (UUID) o escribe el teléfono y presiona Enter.',
    customerNotFound: 'Cliente no encontrado en el programa de lealtad.',
    notMemberYet: 'Este cliente aún no es miembro de tu programa. La primera compra lo inscribirá.',
    enroll: 'Inscribir',
    enrollCustomer: 'Inscribir cliente',
    clientEnrolled: 'Cliente inscrito',
    firstName: 'Nombre',
    lastName: 'Apellido',
    phoneHint: 'Se asume Guatemala (+502) si no se indica código de país.',
    viewProfile: 'Ver perfil',
    currentPoints: 'Puntos actuales',
    lifetimePoints: 'Puntos acumulados',
    totalSpent: 'Total gastado',
    visits: 'Visitas',
    firstVisit: 'Primera visita',
    lastVisit: 'Última visita',
    birthday: 'Cumpleaños',
    location: 'Sucursal',
    singleLocationHint: 'Única sucursal — preseleccionada',
    registerPurchase: 'Registrar compra',
    purchaseTotal: 'Total de la compra',
    reference: 'Referencia (ticket / factura)',
    pointsEarned: 'Puntos ganados',
    rule: 'Regla',
    points: 'puntos',
    purchaseRegistered: 'Compra registrada exitosamente',
    newBalance: 'Nuevo saldo',
    redeemReward: 'Canjear recompensa',
    rewardRedeemed: 'Recompensa canjeada',
    redeem: 'Canjear',
    noRewards: 'No hay recompensas configuradas.',
    members: 'Miembros del programa',
    searchMembers: 'Buscar por nombre, teléfono o correo…',
    noMembers: 'Aún no hay miembros',
    transactions: 'Transacciones',
    pointsActivity: 'Movimientos de puntos',
    rewardsRedeemed: 'Recompensas canjeadas',
    type: 'Tipo',
    cashier: 'Cajero',
    customer: 'Cliente',
    change: 'Cambio',
    balanceBefore: 'Antes',
    balanceAfter: 'Después',
    by: 'Por',
    reward: 'Recompensa',
    pointsSpent: 'Puntos usados',
    adjustPoints: 'Ajustar puntos',
    adjustHint: 'Positivo suma puntos, negativo resta puntos.',
    pointsAdjusted: 'Puntos ajustados',
    rewards: 'Recompensas',
    newReward: 'Nueva recompensa',
    editReward: 'Editar recompensa',
    pointsRequired: 'Puntos requeridos',
    validity: 'Vigencia',
    redemptions: 'canjes',
    startsAt: 'Inicia',
    endsAt: 'Termina',
    rewardSaved: 'Recompensa guardada',
    rewardDeleted: 'Recompensa eliminada',
    deleteRewardConfirm: '¿Eliminar esta recompensa?',
    all: 'Todas',
    from: 'Desde',
    to: 'Hasta',
    refund: 'Reembolsar',
    refunded: 'Compra reembolsada',
    refundConfirm: '¿Reembolsar esta compra? Los puntos ganados se restarán del saldo del cliente.',
    settings: 'Configuración de lealtad',
    settingsSubtitle: 'Define cómo ganan puntos tus miembros y lo que ven en la app.',
    programActive: 'Programa activo',
    programInactive: 'Programa inactivo',
    programSettings: 'Configuración del programa',
    enableProgram: 'Activar programa de lealtad',
    enableHint: 'Muestra el panel de lealtad en la página de inicio.',
    pointsPerCurrency: 'Puntos por unidad de moneda',
    pointsPerCurrencyHint: 'Ejemplo: 1 = cada Q1 gastado gana 1 punto.',
    birthdayBonus: 'Puntos de cumpleaños',
    birthdayBonusHint: "0 = desactivado. Se regalan una vez al año en el cumpleaños del miembro (requiere fecha en su perfil).",
    settingsSaved: 'Configuración guardada',
    promotions: 'Promociones y novedades',
    promotionsSubtitle: 'Publicaciones que ven tus miembros en la app Mi Lealtad.',
    newPromotion: 'Nueva publicación',
    editPromotion: 'Editar publicación',
    promotionTypePromo: 'Promoción',
    promotionTypeAnnouncement: 'Anuncio',
    promotionTitle: 'Título',
    promotionTitlePlaceholder: 'Tu titular aquí',
    promotionBody: 'Mensaje',
    audience: 'Quién lo ve',
    audienceMembers: 'Solo miembros',
    audiencePublic: 'Todos',
    audienceMembersHint: 'Se muestra en novedades y en la página del negocio para clientes inscritos.',
    audiencePublicHint: 'También se muestra en la página de tu negocio a usuarios de la app que aún no son miembros.',
    promotionPublish: 'Publicada',
    promotionPreview: 'Vista previa en la app',
    promotionEndsOn: 'Hasta el {date}',
    promotionNoEnd: 'Sin fecha de fin',
    promotionSaved: 'Publicación guardada',
    promotionDeleted: 'Publicación eliminada',
    deletePromotionConfirm: '¿Eliminar esta publicación? Los clientes dejarán de verla.',
    noPromotions: 'Aún no hay publicaciones',
    noPromotionsHint: 'Comparte una promoción, producto nuevo o cambio de horario con tus miembros.',
    promotionUsage: '{used} de {max} publicaciones activas',
    promotionLimitHint: 'Llegaste al límite de {max} publicaciones activas. Aún puedes guardar un borrador.',
    promotionFilterAll: 'Todas',
    promotionFilterEnded: 'Finalizadas / apagadas',
    promotionStatus: { live: 'Activa', scheduled: 'Programada', expired: 'Finalizada', inactive: 'Apagada' },
    imageAdd: 'Agregar foto (opcional)',
    imageHint: 'PNG, JPG o WebP · máx. 4 MB · se muestra en la app del cliente',
    imageSize: 'Tamaño recomendado: 1200 × 600 px (horizontal). Mantén lo importante al centro; los bordes pueden recortarse en la app.',
    imageReplace: 'Reemplazar',
    imageRemove: 'Quitar foto',
    imageInvalid: 'Elige un archivo de imagen.',
    imageTooLarge: 'La imagen debe pesar 4 MB o menos.',
    enabledByProfile: 'Siempre activo para negocios con perfil Programa de lealtad.',
    earningRules: 'Reglas de acumulación',
    birthdayBonusOn: '🎂 +{points} pts en su cumpleaños',
    birthdayBonusOff: 'Desactivado',
    birthdayBonusSchedule: 'Se otorga automáticamente cada mañana a las 8:00 a miembros con cumpleaños en su perfil.',
    previewTitle: 'Lo que reciben tus miembros',
    previewPurchase: 'Compra de Q100 = {points} pts',
    previewPurchaseSub: 'Ganados en caja al mostrar su código',
    previewBirthday: '{points} pts de regalo de cumpleaños',
    previewBirthdaySub: 'Una vez al año, automático',
    previewBirthdayOff: 'Sin regalo de cumpleaños',
    previewBirthdayOffSub: 'Define puntos arriba para sorprender a tus miembros',
    previewRewards: 'Catálogo de recompensas',
    previewRewardsSub: 'Adminístralo en Lealtad → Recompensas',
    previewDisabled: 'Programa desactivado — los miembros aún no ganan puntos.',
    birthdayToday: '🎂 ¡Hoy es su cumpleaños!',
    errorLoading: 'Error al cargar datos de lealtad',
    errorSaving: 'Error al guardar',
    active30d: 'Activos 30d',
    newThisMonth: 'Nuevos este mes',
    revenueThisMonth: 'Ventas este mes',
    purchases: 'compras',
    avgTicket: 'ticket promedio',
    vsLastMonth: 'vs mes anterior',
    pointsIssuedThisMonth: 'Puntos emitidos este mes',
    outstanding: 'En circulación',
    pointsRedeemedThisMonth: 'Puntos canjeados este mes',
    redemptionRate: 'tasa de canje',
    trend: 'Últimos 6 meses',
    revenue: 'Ventas',
    pointsIssued: 'Puntos emitidos',
    pointsRedeemed: 'Puntos canjeados',
    topRewards30d: 'Recompensas más canjeadas (30 días)',
    noRedemptionsYet: 'Aún no hay canjes',
    topMembers: 'Mejores miembros',
    recentActivity: 'Movimientos recientes',
    noActivityYet: 'Aún no hay movimientos',
    ledgerTypes: {
      POINTS_EARNED: 'Puntos ganados',
      REWARD_REDEMPTION: 'Canje de recompensa',
      MANUAL_ADJUSTMENT: 'Ajuste manual',
      BONUS: 'Bono',
      REFUND: 'Reembolso',
      POINTS_EXPIRED: 'Puntos vencidos',
    },
  },
 locations: {
    title: 'Bodegas',
    newLocation: 'Nueva Bodega',
    editLocation: 'Editar Bodega',
    deleteLocation: 'Eliminar Bodega',
    noLocationsFound: 'No se encontraron bodegas',
    createFirstLocation: 'Crea tu primera bodega para comenzar',
    locationInformation: 'Información de la Bodega',
    searchLocations: 'Buscar bodegas...',
    name: 'Nombre',
    address: 'Dirección',
  phone: 'Teléfono',
    actions: 'Acciones',
    deletedLocation: 'Bodega eliminada correctamente',
    errorDeletingLocation: 'Error al eliminar la bodega',
    deleteConfirmation: '¿Estás seguro de que quieres eliminar esta bodega?',
    errorLoadingLocations: 'Error al cargar bodegas',
    errorLoadingLocation: 'Error al cargar bodega',
    locationUpdatedSuccess: 'Bodega actualizada correctamente',
    locationCreatedSuccess: 'Bodega creada correctamente',
   },
   // Origins
 origins: {
  title: 'Origenes',
  newOrigin: 'Nuevo Origen',
  editOrigin: 'Editar Origen',
  deleteOrigin: 'Eliminar Origen',
  noOriginsFound: 'No se encontraron orígenes',
  createFirstOrigin: 'Crea tu primer origen para comenzar',
  originInformation: 'Información del Origen',
  searchOrigins: 'Buscar orígenes...',
  name: 'Nombre',
  code: 'Codigo',
  description: 'Descripción',
  status: 'Activo',
  actions: 'Acciones',
  helperText: 'Un código único para referencia programática (ej., "cliente", "proveedor")',
  nameRequiredHelper: 'Se requiere al menos un nombre (Inglés o Español)',
  errorLoadingOrigin: 'Error al cargar origen',
  pleaseFillOneName: 'Por favor completa al menos un nombre (Inglés o Español)',
  originUpdatedSuccess: 'Origen actualizado correctamente',
  originCreatedSuccess: 'Origen creado correctamente',
  errorLoadingOrigins: 'Error al cargar orígenes',
  originDeletedSuccess: 'Origen eliminado correctamente',
  errorUpdatingOrigin: 'Error al actualizar origen',
 },
 // Providers
 providers: {
  title: 'Proveedores',
  newProvider: 'Nuevo Proveedor',
  editProvider: 'Editar Proveedor',
  deleteProvider: 'Eliminar Proveedor',
  noProvidersFound: 'No se encontraron proveedores',
  createFirstProvider: 'Crea tu primer proveedor para comenzar',
  providerInformation: 'Información del Proveedor',
  confirmDeletion: '¿Estás seguro de que quieres eliminar este proveedor?',
  searchProviders: 'Buscar proveedores...',
  name: 'Nombre',
  code: 'Codigo',
  email: 'Correo',
  phone: 'Teléfono',
  address: 'Dirección',
  description: 'Descripción',
  status: 'Activo',
  actions: 'Acciones',
  helperText: 'Un código único para referencia programática',
  nameRequiredHelper: 'Se requiere al menos un nombre (Inglés o Español)',
  errorLoadingProviders: 'Error al cargar proveedores',
  providerDeletedSuccess: 'Proveedor eliminado correctamente',
  providerUpdatedSuccess: 'Proveedor actualizado correctamente',
  errorUpdatingProvider: 'Error al actualizar proveedor',
  errorLoadingProvider: 'Error al cargar proveedor',
  pleaseFillProviderName: 'Por favor ingresa el nombre del proveedor',
  providerCreatedSuccess: 'Proveedor creado correctamente',
 },

  // Inventories
  inventories: {
    title: 'Inventario (Kardex)',
    newInventory: 'New Inventory',
    editInventory: 'Editar Inventario',
    deleteInventory: 'Eliminar Inventario',
    noInventoriesFound: 'No se encontraron inventarios',
    createFirstInventory: 'Crea tu primer inventario para comenzar',
    inventoryInformation: 'Información del Inventario',
    searchInventories: 'Buscar inventarios...',
    NewBuy: 'Nuevo Compra',
    NewSell: 'Nuevo Venta',
    Buy: 'Compra',
    Sell: 'Venta',
    Date: 'Fecha',
  Type: 'Tipo',
    Tracking: 'Seguimiento',
    Product: 'Producto',
    Location: 'Bodega',
    Quantity: 'Cantidad',
    UnitPrice: 'Precio Unitario',
    Total: 'Total',
    TransactionTotal: 'Total Transacción',
    StockTotal: 'Total Inventario',
    RemainingInventory: 'Inventario Restante',
    AvailableInventory: 'Inventario Disponible',
    InsufficientInventory: 'Inventario insuficiente',
    Origin: 'Origen',
    Provider: 'Proveedor',
    NoProvider: 'Sin Proveedor',
    Attachment: 'Adjunto',
    Actions: 'Acciones',
    New: 'Nueva',
    SelectProduct: 'Seleccionar Producto',
    NoLocation: 'Sin Bodega',
    NoOrigin: 'Sin Origen',
    Notes: 'Notas',
    Transaction: 'Transacción',
    NoTransactionsFound: 'No se encontraron transacciones',
    Date: 'Date',
    Type: 'Tipo',
  Product: 'Product',
    Location: 'Bodega',
    Quantity: 'Cantidad',
    UnitPrice: 'Precio Unitario',
    Total: 'Total',
    Origin: 'Origen',
    Attachment: 'Adjunto',
  Actions: 'Acciones',
    errorLoadingInventories: 'Error al cargar inventarios',
    transactionDeletedSuccess: 'Transacción eliminada correctamente',
    errorDeletingTransaction: 'Error al eliminar transacción',
    errorLoadingTransaction: 'Error al cargar transacción',
    quantityRequired: 'La cantidad es requerida',
    unitPriceRequired: 'El precio unitario es requerido',
    quantityMustBeValid: 'La cantidad debe ser un número positivo válido',
    unitPriceMustBeValid: 'El precio unitario debe ser un número no negativo válido',
    productRequired: 'El producto es requerido',
    transactionUpdatedSuccess: 'Transacción actualizada correctamente',
    transactionCreatedSuccess: 'Transacción creada correctamente',
 },
 reports: {
  title: 'Reportes',
  chooseReport: 'Selecciona un reporte para ver métricas y gráficos.',
  openReport: 'Abrir reporte',
  sectionInventorySales: 'Inventario y Ventas',
  sectionPayments: 'Pagos',
  sectionClinic: 'Clínica',
  sectionCleaning: 'Limpieza y cronograma',
  sectionSchool: 'Escuela',
  attendanceStudentSummary: 'Resumen de asistencia por estudiante',
  attendanceStudentSummaryDescription:
    'Por estudiante en un rango de fechas: presente, ausente, tarde y días sin marca.',
  attendanceSchoolWide: 'Toda la escuela',
  attendanceUnmarked: '{count} días sin marca (total)',
  attendanceUnmarkedDays: 'Días sin marca',
  attendanceDaysInRange: '{count} días en el rango',
  attendanceStatusFilter: 'Mostrar estudiantes',
  attendanceStatusAll: 'Todos los estudiantes',
  attendanceStatusPresent: 'Con días presentes',
  attendanceStatusAbsent: 'Con ausencias',
  attendanceStatusLate: 'Con llegadas tarde',
  attendanceStatusUnmarked: 'Con días sin marca',
  attendanceShowingCount: 'Mostrando {count} de {total} estudiantes',
  attendanceNoStudentsForFilter: 'Ningún estudiante coincide con este filtro.',
  clinicAppointmentBookings: 'Reservas de citas',
  clinicAppointmentBookingsDescription:
    'Citas en un rango de fechas: total, confirmadas con asistencia, confirmadas sin asistir (fechas pasadas) y canceladas. Marca llegada en el calendario para conteos correctos.',
  clinicTotalBookings: 'Total de reservas',
  clinicConfirmedShowedUp: 'Confirmadas y asistieron',
  clinicConfirmedNoShow: 'Confirmadas, no asistieron',
  clinicConfirmedUpcoming: 'Confirmadas, próximas',
  clinicCancelled: 'Canceladas',
  clinicPending: 'Pendientes (sin confirmar)',
  clinicChartTitle: 'Resumen de reservas',
  clinicPendingCount: 'Pendientes: {count}',
  clinicUpcomingCount: 'Confirmadas próximas: {count}',
  productInventory: 'Producto e Inventario',
  totalSales: 'Ventas Totales',
  salesByProduct: 'Ventas por Producto',
  earningsByBatch: 'Ganancias por Lote',
  productInventoryDescription: 'Ver niveles de inventario actuales para todos los productos',
  totalSalesDescription: 'Ver estadísticas y tendencias de ventas totales',
  salesByProductDescription: 'Ver desglose de ventas por producto',
  earningsByBatchDescription: 'Ver análisis de ganancias por lote (precio de compra vs precio de venta)',
  product: 'Producto',
  currentInventory: 'Inventario Actual',
  remainingInventory: 'Inventario Restante',
  totalBuyQuantity: 'Cantidad Total Comprada',
  totalBuyValue: 'Valor Total Comprado',
  totalSellQuantity: 'Cantidad Total Vendida',
  totalSellValue: 'Valor Total Vendido',
  trackingMethod: 'Método de Seguimiento',
  totalSalesAmount: 'Monto Total de Ventas',
  totalQuantity: 'Cantidad Total',
  totalTransactions: 'Total de Transacciones',
  salesByDate: 'Ventas por Fecha',
  date: 'Fecha',
  transactions: 'Transacciones',
  saleCount: 'Cantidad de Ventas',
  buyDate: 'Fecha de Compra',
  revenue: 'Ingresos',
  cost: 'Costo',
  profit: 'Ganancia',
  profitMargin: 'Margen de Ganancia',
  totalRevenue: 'Ingresos Totales',
  totalCost: 'Costo Total',
  totalProfit: 'Ganancia Total',
  startDate: 'Fecha Inicio',
  endDate: 'Fecha Fin',
  filter: 'Filtrar',
  reset: 'Restablecer',
  searchProducts: 'Buscar productos...',
  noData: 'No hay datos disponibles',
  errorLoading: 'Error al cargar datos',

  paymentsActiveMembershipsByMonth: 'Membrecías activas por mes',
  paymentsActiveMembershipsByMonthDescription: 'Total de membrecías activas por mes (últimos 12 meses).',
  activeMembershipsThisMonth: 'Membrecías activas este mes: {count}',

  paymentsActiveClientsCounts: 'Clientes con membrecías activas',
  paymentsActiveClientsCountsDescription: 'Total de clientes con membrecías activas y cuántas tiene cada uno.',
  totalActiveClients: 'Clientes activos: {count}',
  totalActiveMemberships: 'Membrecías activas: {count}',
  activeMemberships: 'Membrecías activas',

  paymentsIncomeByDateRange: 'Ingresos por rango de fechas',
  paymentsIncomeByDateRangeDescription: 'Total de ingresos por pagos de membrecías en un rango de fechas.',
  totalIncome: 'Ingresos totales',

  cleaningHoursWagesByCleaner: 'Horas y salarios por personal',
  cleaningHoursWagesByCleanerDescription:
    'Cada fila es una persona en un trabajo ese día. Las horas mostradas son las horas del trabajo entre la cantidad de personas asignadas ese día (misma repartición que el salario por trabajo). El salario por hora usa esa parte × la tarifa; el salario del trabajo reparte el total entre esas personas.',
  cleaningHoursByClient: 'Horas de trabajo por cliente',
  cleaningHoursByClientDescription:
    'Horas por cliente por día. Cada trabajo cuenta una vez al día (no se multiplica por cantidad de personas).',
  cleaningCleaner: 'Personal',
  cleaningClient: 'Cliente',
  cleaningHours: 'Horas',
  cleaningJobName: 'Nombre del trabajo',
  cleaningDaySubtotal: 'Subtotal del día',
  cleaningTotalHours: 'Horas totales',
  cleaningWagesByHourly: 'Salario (hora × tarifa)',
  cleaningWagesByJob: 'Salario (trabajo ÷ personal ese día)',
  cleaningTabDetail: 'Por día',
  cleaningTabByCleaner: 'Por personal (totales)',
  cleaningTabByClient: 'Por cliente (totales)',
  cleaningFilterByCleaner: 'Filtrar por personal',
  cleaningFilterAllCleaners: 'Todo el personal',
  cleaningChartHoursByDay: 'Horas totales por día (todo el personal)',
  cleaningChartWagesByDay: 'Salario total por día (todo el personal)',
  cleaningChartPayByCleaner: 'Total a pagar por persona (rango)',
  cleaningChartPayByCleanerHint: 'Las barras usan la base de salario seleccionada abajo.',
  cleaningWageBasisLabel: 'Base para "Total a recibir" (pestaña por personal)',
  cleaningWageBasisHourly: 'Hora × tarifa',
  cleaningWageBasisJob: 'Parte del salario del trabajo',
  cleaningAmountToReceive: 'Total a recibir (rango)',
  cleaningHoursByDayChart: 'Horas de trabajo por día (todos los clientes)',
 },
 students: {  
  title: 'Estudiantes',
  newStudent: 'Nuevo Estudiante',
  editStudent: 'Editar Estudiante',
  updateStudent: 'Actualizar Estudiante',
  saveStudent: 'Guardar Estudiante',
  studentName: 'Nombre del Estudiante',
  studentCode: 'Código del Estudiante',
  studentCodeHelper: 'Identificador único del estudiante.',
  deleteStudent: 'Eliminar Estudiante',
  noStudentsFound: 'No se encontraron estudiantes',
  createFirstStudent: 'Crea tu primer estudiante para comenzar',
  studentInformation: 'Información del Estudiante',
  searchStudents: 'Buscar estudiantes...',
  deletedStudents: 'Estudiantes Eliminados',
  searchPlaceholder: 'Buscar estudiantes por nombre o código...',
  code: 'Código',
  createdAt: 'Fecha de Creación',
  bulkAssignGrade: 'Asignar Grado en Lote',
  assignGrade: 'Asignar Grado',
  deleteStudentTitle: 'Eliminar Estudiante',
  deleteStudentConfirm: '¿Estás seguro de que quieres eliminar este estudiante? Esta acción se puede deshacer.',
  assignGradeTitle: 'Asignar Grado a {name}',
  bulkAssignGradeTitle: 'Asignar Grado en Lote a {count} Estudiante(s)',
  grade: 'Grado',
  cycle: 'Ciclo',
  selectBothGradeCycle: 'Por favor selecciona tanto el grado como el ciclo',
  selectAtLeastOne: 'Por favor selecciona al menos un estudiante',
  gradeAssignedSuccess: 'Grado asignado al estudiante exitosamente',
  gradeAssignedBulkSuccess: 'Grado asignado a {count} estudiante(s) exitosamente',
  assignedWithErrors: 'Asignado a {successCount} estudiante(s), {errorCount} fallaron',
  errorAssigningGrade: 'Error al asignar grado al estudiante',
  errorAssigningGrades: 'Error al asignar grados',
  studentDeletedSuccess: 'Estudiante eliminado exitosamente',
  errorDeletingStudent: 'Error al eliminar estudiante',
  errorLoadingStudents: 'Error al cargar estudiantes',
  moreActions: 'Más acciones',
  assignGradeToAll: 'Asignar a Todos',
  bulkAssignDescription: 'Esto asignará el grado y ciclo seleccionados a los {count} estudiante(s) seleccionado(s).',
  searchDeletedPlaceholder: 'Buscar estudiantes eliminados por nombre o código...',
  deletedAt: 'Fecha de Eliminación',
  noDeletedStudentsFound: 'No se encontraron estudiantes eliminados',
  restoreStudent: 'Restaurar Estudiante',
  restoreStudentTitle: 'Restaurar Estudiante',
  restoreStudentConfirm: '¿Estás seguro de que quieres restaurar {name}?',
  studentRestoredSuccess: 'Estudiante restaurado exitosamente',
  errorRestoringStudent: 'Error al restaurar estudiante',
  errorLoadingDeletedStudents: 'Error al cargar estudiantes eliminados',
  errorLoadingStudent: 'Error al cargar estudiante',
  studentUpdatedSuccess: 'Estudiante actualizado correctamente',
  studentCreatedSuccess: 'Estudiante creado correctamente',
 },
 employees: {
  title: 'Empleados',
  newEmployee: 'Nuevo empleado',
  editEmployee: 'Editar empleado',
  deleteEmployee: 'Eliminar empleado',
  noEmployeesFound: 'No se encontraron empleados',
  searchEmployees: 'Buscar empleados...',
  confirmDeletion: '¿Seguro que deseas eliminar este empleado?',
  name: 'Nombre',
  email: 'Correo',
  phone: 'Teléfono',
  role: 'Rol',
  status: 'Estado',
  hourlyRate: 'Tarifa por hora',
  overtimeRate: 'Tarifa horas extra',
  maxHoursPerDay: 'Máx. horas / día',
  maxHoursPerWeek: 'Máx. horas / semana',
  color: 'Color en calendario',
  hireDate: 'Fecha de ingreso',
  actions: 'Acciones',
  roleCleaner: 'Limpieza',
  roleSupervisor: 'Supervisor',
  roleAdmin: 'Administrador',
  statusActive: 'Activo',
  statusInactive: 'Inactivo',
  errorLoadingEmployees: 'Error al cargar empleados',
  errorLoadingEmployee: 'Error al cargar empleado',
  errorDeletingEmployee: 'Error al eliminar empleado',
  employeeDeletedSuccess: 'Empleado eliminado correctamente',
  employeeUpdatedSuccess: 'Empleado actualizado correctamente',
  employeeCreatedSuccess: 'Empleado creado correctamente',
  pleaseFillName: 'Ingresa el nombre del empleado',
  invalidHourlyRate: 'Ingresa una tarifa por hora válida',
  invalidHours: 'Ingresa límites de horas válidos',
  invalidOvertimeRate: 'Ingresa una tarifa de horas extra válida',
 },
 cycles: {
  title: 'Ciclos',
  newCycle: 'Nuevo Ciclo',
  deletedCycles: 'Ciclos Eliminados',
  searchPlaceholder: 'Buscar ciclos por nombre...',
  searchDeletedPlaceholder: 'Buscar ciclos eliminados por nombre...',
  name: 'Nombre',
  createdAt: 'Fecha de Creación',
  deletedAt: 'Fecha de Eliminación',
  noCyclesFound: 'No se encontraron ciclos',
  noDeletedCyclesFound: 'No se encontraron ciclos eliminados',
  deleteCycleTitle: 'Eliminar Ciclo',
  deleteCycleConfirm: '¿Estás seguro de que quieres eliminar este ciclo? Esta acción se puede deshacer.',
  cycleDeletedSuccess: 'Ciclo eliminado correctamente',
  errorDeletingCycle: 'Error al eliminar ciclo',
  errorLoadingCycles: 'Error al cargar ciclos',
  restoreCycle: 'Restaurar Ciclo',
  restoreCycleTitle: 'Restaurar Ciclo',
  restoreCycleConfirm: '¿Estás seguro de que quieres restaurar {name}?',
  cycleRestoredSuccess: 'Ciclo restaurado correctamente',
  errorRestoringCycle: 'Error al restaurar ciclo',
  errorLoadingDeletedCycles: 'Error al cargar ciclos eliminados',
  editCycle: 'Editar Ciclo',
  updateCycle: 'Actualizar Ciclo',
  saveCycle: 'Guardar Ciclo',
  cycleName: 'Nombre del Ciclo',
  cycleUpdatedSuccess: 'Ciclo actualizado correctamente',
  cycleCreatedSuccess: 'Ciclo creado correctamente',
  errorLoadingCycle: 'Error al cargar ciclo',
  pleaseFillRequired: 'Por favor completa todos los campos requeridos',
 },
 grades: {
  title: 'Grados',
  newGrade: 'Nuevo Grado',
  deletedGrades: 'Grados Eliminados',
  searchPlaceholder: 'Buscar grados por nombre...',
  searchDeletedPlaceholder: 'Buscar grados eliminados por nombre...',
  name: 'Nombre',
  createdAt: 'Fecha de Creación',
  deletedAt: 'Fecha de Eliminación',
  noGradesFound: 'No se encontraron grados',
  noDeletedGradesFound: 'No se encontraron grados eliminados',
  deleteGradeTitle: 'Eliminar Grado',
  deleteGradeConfirm: '¿Estás seguro de que quieres eliminar este grado? Esta acción se puede deshacer.',
  gradeDeletedSuccess: 'Grado eliminado correctamente',
  errorDeletingGrade: 'Error al eliminar grado',
  errorLoadingGrades: 'Error al cargar grados',
  restoreGrade: 'Restaurar Grado',
  restoreGradeTitle: 'Restaurar Grado',
  restoreGradeConfirm: '¿Estás seguro de que quieres restaurar {name}?',
  gradeRestoredSuccess: 'Grado restaurado correctamente',
  errorRestoringGrade: 'Error al restaurar grado',
  errorLoadingDeletedGrades: 'Error al cargar grados eliminados',
  editGrade: 'Editar Grado',
  updateGrade: 'Actualizar Grado',
  saveGrade: 'Guardar Grado',
  gradeName: 'Nombre del Grado',
  gradeUpdatedSuccess: 'Grado actualizado correctamente',
  gradeCreatedSuccess: 'Grado creado correctamente',
  errorLoadingGrade: 'Error al cargar grado',
  pleaseFillRequired: 'Por favor completa todos los campos requeridos',
 },
 planifications: {
  title: 'Planificaciones',
  typesButton: 'Tipos',
  deleted: 'Eliminados',
  new: 'Nuevo',
  searchPlaceholder: 'Buscar por nombre o tipo...',
  emptyList: 'No se encontraron planificaciones. Crea una con "Nuevo" o agrega una hija bajo una planificación existente.',
  addChild: 'Agregar planificación hija',
  send: 'Enviar',
  downloadPdf: 'Descargar PDF',
  deleteTitle: 'Eliminar Planificación',
  deleteConfirm: '¿Estás seguro de que deseas eliminar {name}?',
  restoreTitle: 'Restaurar Planificación',
  restoreTypeTitle: 'Restaurar Tipo',
  restoreConfirm: '¿Estás seguro de que deseas restaurar {name}?',
  statusDraft: 'borrador',
  statusSent: 'enviado',
  statusInReview: 'En Revisión',
  statusNeedsChanges: 'Requiere Cambios',
  statusApproved: 'aprobado',
  typesTitle: 'Tipos de Planificación',
  newType: 'Nuevo Tipo',
  searchTypes: 'Buscar tipos...',
  noTypesFound: 'No se encontraron tipos de planificación.',
  deleteTypeTitle: 'Eliminar Tipo de Planificación',
  deleteTypeConfirm: '¿Estás seguro de que deseas eliminar {name}?',
  deleteTypeConfirmSoft: 'Es una eliminación temporal. Puedes restaurarlo desde la lista de eliminados.',
  addChildType: 'Agregar tipo hijo',
  child: 'Hijo',
  root: 'Raíz',
  editPlanification: 'Editar Planificación',
  newPlanification: 'Nueva Planificación',
  typeOfPlanification: 'Tipo de planificación',
  selectTypePlaceholder: 'Seleccionar tipo (Bimestral, semanal, Diaria…)',
  typeHelper: 'Elige qué tipo de planificación es (ej. Bimestral, semanal, Diaria).',
  infoSelectType: 'Selecciona el tipo de planificación (ej. Bimestral, semanal, Diaria) para este plan. También puedes agregar una hija haciendo clic en "Agregar" en una fila de la lista.',
  typeSelectedBelow: 'Tipo: {name} (puedes cambiarlo abajo)',
  parentPlanification: 'Planificación padre',
  noneTopLevel: 'Ninguno (nivel superior)',
  parentHelper: 'Solo se listan planificaciones de nivel superior. Elige una para que esta aparezca anidada bajo ella.',
  shareWith: 'Compartir con',
  shareWithHelp: 'Agrega usuarios que puedan ver o editar esta planificación. La verán en su lista.',
  addUser: 'Agregar usuario',
  permissionView: 'Ver',
  permissionEdit: 'Editar',
  permissionLabel: 'Permiso',
  noAssignedUsers: 'Ningún usuario asignado. Agrega a alguien para que pueda ver esta planificación.',
  alreadyAssigned: 'Este usuario ya está asignado.',
  assignmentsNotAvailable: 'Las asignaciones no están disponibles. Ejecuta las migraciones para habilitar compartir.',
  assignmentsSaved: 'Asignaciones guardadas.',
  parentHelperCreate: 'Esta planificación se creará bajo: {name}. Elige el tipo (ej. semanal, Diaria) para esta hija abajo.',
  startReview: 'Iniciar Revisión',
  needsChanges: 'Requiere Cambios',
  approve: 'Aprobar',
  attachmentsTitle: 'Adjuntos (Planificación)',
  upload: 'Subir',
  noAttachments: 'Sin adjuntos aún.',
  startDate: 'Fecha de Inicio',
  endDate: 'Fecha de Fin',
  saveSection: 'Guardar Sección',
  content: 'Contenido',
  sectionAttachments: 'Adjuntos de Sección',
  uploadFilesPlanification: 'Sube archivos para toda la planificación.',
  noSectionAttachments: 'Sin adjuntos en la sección.',
  comments: 'Comentarios',
  noCommentsYet: 'Sin comentarios aún.',
  addComment: 'Agregar comentario',
  setNeedsChanges: 'Marcar Requiere Cambios',
  add: 'Agregar',
  reviewer: 'Revisor',
  curso: 'Curso',
  cursoOptional: 'Opcional. Vincula esta planificación a un curso.',
  deletedPlanificationsTitle: 'Planificaciones Eliminadas',
  deletedTypesTitle: 'Tipos de Planificación Eliminados',
  searchDeleted: 'Buscar planificaciones eliminadas por nombre...',
  searchDeletedTypes: 'Buscar tipos eliminados por nombre...',
  noDeletedFound: 'No se encontraron planificaciones eliminadas',
  noDeletedTypesFound: 'No se encontraron tipos de planificación eliminados',
  deletedAt: 'Eliminado el',
  restore: 'Restaurar',
  errorLoadingPlanificationTypes: 'Error al cargar tipos de planificación',
  planificationTypeDeletedSuccess: 'Tipo de planificación eliminado correctamente',
  errorDeletingPlanificationType: 'Error al eliminar tipo de planificación',
  errorLoadingPlanificationType: 'Error al cargar tipo de planificación',
  planificationTypeUpdated: 'Tipo de planificación actualizado',
  planificationTypeCreated: 'Tipo de planificación creado',
  errorLoadingPlanifications: 'Error al cargar planificaciones',
  planificationSent: 'Planificación enviada',
  pdfDownloadedSuccess: 'PDF descargado correctamente',
  planificationDeleted: 'Planificación eliminada',
  errorDeletingPlanification: 'Error al eliminar planificación',
  errorLoadingPlanification: 'Error al cargar planificación',
  planificationUpdated: 'Planificación actualizada',
  planificationCreated: 'Planificación creada',
  typeRequired: 'El tipo es requerido',
  statusUpdated: 'Estado actualizado',
  sectionSaved: 'Sección guardada',
  errorSavingSection: 'Error al guardar sección',
  commentRequired: 'El comentario es requerido',
  commentAdded: 'Comentario agregado',
  errorAddingComment: 'Error al agregar comentario',
  fileUploaded: 'Archivo subido',
  errorUploadingFile: 'Error al subir archivo',
  editPlanificationType: 'Editar Tipo de Planificación',
  newPlanificationType: 'Nuevo Tipo de Planificación',
  parentOptional: 'Padre (opcional)',
  none: 'Ninguno',
  sections: 'Secciones',
  addSection: 'Agregar Sección',
  noSectionsYet: 'Sin secciones aún. Agrega tantas secciones de texto como necesites.',
  sectionName: 'Nombre de Sección',
  defaultTextOptional: 'Texto por Defecto (opcional)',
  sectionNumber: 'Sección {number}',
  moveUp: 'Subir',
  moveDown: 'Bajar',
  remove: 'Quitar',
 },
 permissions: {
  errorLoadingPermissions: 'Error al cargar permisos',
  permissionUpdatedSuccess: 'Permiso actualizado correctamente',
  permissionCreatedSuccess: 'Permiso creado correctamente',
  permissionDeletedSuccess: 'Permiso eliminado correctamente',
  errorDeletingPermission: 'Error al eliminar permiso',
 },
 sales: {
  title: 'Ventas',
  newSale: 'Nueva Venta',
  editSale: 'Editar Venta',
  date: 'Fecha de Venta',
  unitPrice: 'Precio Unitario',
  totalSaleAmount: 'Total de Venta',
  notes: 'Notas',
  additionalNotes: 'Notas adicionales o comentarios',
 },
 support: {
  title: 'Solicitud de Soporte',
  problemLabel: '¿Qué problema está experimentando?',
  problemPlaceholder: 'Por favor describa el problema que está enfrentando...',
  urlLabel: 'URL Actual',
  contactMethodLabel: '¿Cómo le gustaría contactarnos?',
  sendViaEmail: 'Enviar por Correo',
  openWhatsApp: 'Abrir WhatsApp',
  cancel: 'Cancelar',
  submit: 'Enviar',
  sending: 'Enviando...',
  successEmail: '¡Su solicitud de soporte ha sido enviada exitosamente! Nos pondremos en contacto pronto.',
  successWhatsApp: 'Abriendo WhatsApp...',
  errorRequired: 'Por favor describa su problema',
  errorSend: 'Error al enviar la solicitud de soporte. Por favor intente nuevamente.',
  whatsappMessage: 'Hola, necesito soporte con el siguiente problema:\n\nProblema: {problem}\nURL: {url}\n\nPor favor ayúdeme a resolver este problema.',
 },
 pensums: {
  grade: 'Grado',
  newPensum: 'Nuevo Pensum',
  editPensumForGrade: 'Editar Pensum para Grado',
  savePensum: 'Guardar Pensum',
  assignCursosToGrade: 'Asignar Cursos al Grado',
  selectCursosToAssign: 'Selecciona los cursos para asignar a este grado',
  availableCursos: 'Cursos Disponibles',
  selectedCursos: 'Cursos Seleccionados',
  searchCursos: 'Buscar cursos...',
  searchSelected: 'Buscar seleccionados...',
  noCursosAvailable: 'No hay cursos disponibles',
  noCursosSelected: 'Ningún curso seleccionado',
  add: 'Agregar',
  addAll: 'Agregar Todos',
  remove: 'Quitar',
  removeAll: 'Quitar Todos',
  listTitle: 'Pensums',
  filterByGrade: 'Filtrar por Grado',
  allGrades: 'Todos los Grados',
  searchPensums: 'Buscar pensums...',
  deletedPensums: 'Pensums Eliminados',
  order: 'Orden',
  curso: 'Curso',
  noPensumsFound: 'No se encontraron pensums',
  cursosCount: '{count} cursos',
  editPensumTitle: 'Editar pensum',
  deletePensum: 'Eliminar Pensum',
  deletePensumConfirm: '¿Estás seguro de que deseas eliminar este pensum? Esta acción se puede deshacer.',
 },
 cursos: {
  title: 'Cursos',
  deletedCursos: 'Cursos Eliminados',
  newCurso: 'Nuevo Curso',
  editCurso: 'Editar Curso',
  cursoName: 'Nombre del Curso',
  saveCurso: 'Guardar Curso',
  updateCurso: 'Actualizar Curso',
  pleaseFillRequired: 'Por favor completa todos los campos requeridos',
  cursoCreatedSuccess: 'Curso creado exitosamente',
  cursoUpdatedSuccess: 'Curso actualizado exitosamente',
  errorLoadingCurso: 'Error al cargar el curso',
  searchPlaceholder: 'Buscar cursos por nombre...',
  noCursosFound: 'No se encontraron cursos',
  deleteCurso: 'Eliminar Curso',
  deleteCursoConfirm: '¿Estás seguro de que quieres eliminar este curso? Esta acción se puede deshacer.',
  cursoDeletedSuccess: 'Curso eliminado exitosamente',
  errorDeletingCurso: 'Error al eliminar curso',
  errorLoadingCursos: 'Error al cargar cursos',
 },
 attendance: {
  title: 'Asistencia',
  subtitle: 'Marca y registra la asistencia por grado o curso.',
  save: 'Guardar asistencia',
  saving: 'Guardando...',
  byGrade: 'Por grado',
  byCourse: 'Por curso',
  grade: 'Grado',
  course: 'Curso',
  cycle: 'Ciclo',
  date: 'Fecha',
  dateLabel: 'Asistencia del {date}',
  student: 'Estudiante',
  code: 'Código',
  attendanceColumn: 'Asistencia',
  present: 'Presente',
  absent: 'Ausente',
  late: 'Tarde',
  summaryPresent: '{count} presentes',
  summaryAbsent: '{count} ausentes',
  summaryLate: '{count} tarde',
  empty: 'No hay estudiantes para este filtro.',
  saveSuccess: 'Asistencia guardada correctamente.',
  saveError: 'No se pudo guardar la asistencia.',
  nothingToSave: 'Marca al menos un estudiante antes de guardar.',
  errorLoadingSheet: 'No se pudo cargar la hoja de asistencia.',
  errorLoadingFilters: 'No se pudieron cargar grados, cursos o ciclos.',
  noAssignments: 'No tienes grados ni cursos asignados. Contacta al administrador.',
 },
 teacherAssignments: {
  title: 'Asignaciones de docentes',
  subtitle: 'Asigna grados y/o cursos a docentes para limitar la asistencia.',
  teacher: 'Docente',
  add: 'Agregar asignación',
  filterByTeacher: 'Filtrar por docente',
  allTeachers: 'Todos los docentes',
  anyCycle: 'Cualquier ciclo',
  none: 'Ninguno',
  empty: 'Sin asignaciones.',
  saved: 'Asignación agregada.',
  saveError: 'No se pudo guardar la asignación.',
  removed: 'Asignación eliminada.',
  removeError: 'No se pudo eliminar la asignación.',
  errorLoading: 'No se pudieron cargar las asignaciones.',
  needGradeOrCourse: 'Selecciona al menos un grado o un curso.',
  noPermission: 'No tienes permiso para administrar asignaciones de docentes.',
 },
 notas: {
  title: 'Notas',
  saveNotas: 'Guardar Notas',
  curso: 'Curso',
  nota1: 'Nota 1',
  nota2: 'Nota 2',
  nota3: 'Nota 3',
  nota4: 'Nota 4',
  detalle: 'Detalle',
  ausencias: 'Ausencias',
  reportes: 'Reportes',
  tareas: 'Tareas',
  yes: 'Sí',
  no: 'No',
  viewTareas: 'Ver Tareas',
  tareasFor: 'Tareas para {notaType}',
  name: 'Nombre',
  total: 'Total',
  yourPunteo: 'Tu Punteo',
  createNewTarea: 'Crear Nueva Tarea para {notaType}',
  totalPoints: 'Puntos Totales',
  addTarea: 'Agregar Tarea',
  expand: 'Expandir',
  collapse: 'Contraer',
  notasSavedSuccess: 'Notas guardadas exitosamente',
  errorSavingNotas: 'Error al guardar notas',
  errorLoadingStudentData: 'Error al cargar datos del estudiante',
  errorLoadingStudents: 'Error al cargar estudiantes',
  errorLoadingCursos: 'Error al cargar cursos',
  errorLoadingTareas: 'Error al cargar tareas',
  tareaCreatedSuccess: 'Tarea creada exitosamente',
  errorCreatingTarea: 'Error al crear tarea',
  scoreUpdatedSuccess: 'Punteo actualizado exitosamente',
  errorUpdatingScore: 'Error al actualizar punteo',
  tareaDeletedSuccess: 'Tarea eliminada exitosamente',
  errorDeletingTarea: 'Error al eliminar tarea',
  pleaseSaveNotaFirst: 'Por favor guarda la nota primero',
  pleaseSelectGradeCycle: 'Por favor selecciona el grado y ciclo primero',
  pleaseFillAllFields: 'Por favor completa todos los campos',
  byGrade: 'Por Grado',
  byClass: 'Por Clase',
  classInputMode: 'Modo de entrada por clase - Próximamente',
  studentsListTitle: 'Estudiantes',
  input: 'Entrada',
  list: 'Lista',
  pdfGeneratedSuccess: 'PDF generado correctamente',
  errorGeneratingPdf: 'Error al generar PDF',
  pleaseSelectCycle: 'Por favor selecciona un ciclo',
  bulkPdfGeneratedSuccess: 'PDF masivo generado correctamente',
  errorGeneratingBulkPdf: 'Error al generar PDF masivo',
  errorLoadingData: 'Error al cargar datos',
  listCardTitle: 'Lista de Estudiantes',
  bulkPrint: 'Imprimir en Lote',
  searchStudent: 'Buscar Estudiante',
  noStudentsFound: 'No se encontraron estudiantes',
  inputNotas: 'Ingresar Notas',
  printPdf: 'Imprimir PDF',
 },
 pagination: {
  rowsPerPage: 'Filas por página:',
  displayedRows: '{from}-{to} de {count}',
 },
 tenantRegistration: {
  title: 'Registra Tu Empresa',
  subtitle: 'Crea una nueva cuenta de tenant para comenzar con Techno',
  step1: 'Información de la Empresa',
  step2: 'Información de Contacto',
  step3: 'Cuenta de Administrador',
  companyName: 'Nombre de la Empresa',
  subdomain: 'Subdominio',
  subdomainHint: 'Solo letras minúsculas, números y guiones (ej: miempresa)',
  customDomain: 'Dominio Personalizado (Opcional)',
  customDomainHint: 'Tu dominio personalizado (ej: techno.miempresa.com)',
  nit: 'NIT',
  email: 'Correo Electrónico',
  phone: 'Teléfono',
  address: 'Dirección',
  adminAccountTitle: 'Cuenta de Administrador',
  adminAccountDescription: 'Crea la cuenta de administrador para tu tenant. Este usuario tendrá acceso completo para gestionar la configuración de tu empresa.',
  adminName: 'Nombre del Administrador',
  adminEmail: 'Correo del Administrador',
  password: 'Contraseña',
  passwordHint: 'Mínimo 8 caracteres',
  confirmPassword: 'Confirmar Contraseña',
  alreadyHaveAccount: '¿Ya tienes una cuenta?',
  successTitle: '¡Registro Exitoso!',
  successMessage: 'Tu cuenta de tenant ha sido creada exitosamente. Serás redirigido a la página de inicio de sesión en breve.',
  redirecting: 'Redirigiendo al inicio de sesión...',
  errors: {
    nameRequired: 'El nombre de la empresa es requerido',
    subdomainRequired: 'El subdominio es requerido',
    subdomainInvalid: 'El subdominio solo puede contener letras minúsculas, números y guiones',
    emailRequired: 'El correo electrónico es requerido',
    emailInvalid: 'Por favor ingresa un correo electrónico válido',
    adminNameRequired: 'El nombre del administrador es requerido',
    adminEmailRequired: 'El correo del administrador es requerido',
    passwordRequired: 'La contraseña es requerida',
    passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
    passwordMismatch: 'Las contraseñas no coinciden',
    registrationFailed: 'El registro falló. Por favor intenta de nuevo.',
    },
  },
  tenantUsers: {
    title: 'Todos los Usuarios de Tenants',
    addUser: 'Agregar usuario',
    searchPlaceholder: 'Buscar usuarios por nombre, correo o tenant...',
    filterByTenant: 'Filtrar por Tenant',
    name: 'Nombre',
    email: 'Correo',
    tenant: 'Tenant',
    roles: 'Roles',
    status: 'Estado',
    lastLogin: 'Último Inicio de Sesión',
    createdAt: 'Fecha de Creación',
    never: 'Nunca',
    noUsersFound: 'No se encontraron usuarios',
    showingResults: 'Mostrando {from} a {to} de {total} usuarios',
    confirmDelete: '¿Estás seguro de que deseas eliminar este usuario?',
    userDeletedSuccess: 'Usuario eliminado exitosamente',
    errorLoadingData: 'Error al cargar datos de usuarios',
    errorDeletingUser: 'Error al eliminar usuario',
  },
  userManagement: {
    title: 'Gestión de Usuarios',
    addUser: 'Agregar Usuario',
    loadingUsers: 'Cargando usuarios...',
    editUser: 'Editar Usuario',
    createUser: 'Crear Usuario',
    noTenant: 'Sin tenant',
    password: 'Contraseña',
    passwordLeaveEmpty: 'Dejar vacío para mantener la contraseña actual',
    active: 'Activo',
    update: 'Actualizar',
    create: 'Crear',
    userUpdatedSuccess: 'Usuario actualizado exitosamente',
    userCreatedSuccess: 'Usuario creado exitosamente',
    userDeletedSuccess: 'Usuario eliminado exitosamente',
    errorLoadingData: 'Error al cargar datos',
    errorSavingUser: 'Error al guardar usuario',
    errorDeletingUser: 'Error al eliminar usuario',
    confirmDeleteUser: '¿Estás seguro de que deseas eliminar este usuario?',
    moreActions: 'Más acciones',
    sendWelcomeEmail: 'Enviar correo de bienvenida',
    welcomeEmailSentSuccess: 'Correo de bienvenida enviado exitosamente',
    failedSendWelcomeEmail: 'Error al enviar correo de bienvenida',
    noRolesForTenant: 'No hay roles asignados a este tenant. Configura en Roles por Tenant.',
  },

  descounts: {
    title: 'Descuentos',
    newDescount: 'Nuevo Descuento',
    editDescount: 'Editar Descuento',
    saveDescount: 'Guardar Descuento',
    updateDescount: 'Actualizar Descuento',
    deleteDescount: 'Eliminar Descuento',
    deleteConfirm: '¿Estás seguro de que deseas eliminar este descuento?',
    deletedDescounts: 'Descuentos Eliminados',
    restoreDescount: 'Restaurar Descuento',
    restoreConfirm: '¿Estás seguro de que deseas restaurar este descuento?',
    restore: 'Restaurar',
    percentage: 'Porcentaje',
    amount: 'Monto',
    deletedAt: 'Eliminado el',
    searchPlaceholder: 'Buscar descuentos...',
    noDescountsFound: 'No se encontraron descuentos',
    noDeletedFound: 'No se encontraron descuentos eliminados',
    pleaseFillRequired: 'Por favor complete al menos un campo',
    oneOfRequired: 'Ingrese un porcentaje o un monto (solo uno es necesario).',
    onlyOneAllowed: 'Solo se permite uno: porcentaje o monto. Deje el otro campo vacío.',
    percentageOrAmountHint: 'Ingrese solo uno: porcentaje o monto',
    createdSuccess: 'Descuento creado exitosamente',
    updatedSuccess: 'Descuento actualizado exitosamente',
    deletedSuccess: 'Descuento eliminado exitosamente',
    restoredSuccess: 'Descuento restaurado exitosamente',
    errorLoading: 'Error al cargar descuentos',
    errorLoadingDescount: 'Error al cargar descuento',
    errorDeleting: 'Error al eliminar descuento',
    errorRestoring: 'Error al restaurar descuento',
    errorSaving: 'Error al guardar descuento',
    status: 'Estado',
    statusActive: 'Activo',
    statusInactive: 'Inactivo',
    startDate: 'Fecha de Inicio',
    endDate: 'Fecha de Fin',
    activate: 'Activar',
    deactivate: 'Desactivar',
    activatedSuccess: 'Descuento activado',
    deactivatedSuccess: 'Descuento desactivado',
    errorUpdating: 'Error al actualizar descuento',
  },

  clientPayments: {
    title: 'Membrecía',
    subtitle: 'Gestiona las membrecías y asignaciones de pago de clientes',
    assignNew: 'Asignar Membrecía',
    assignDescription: 'Asigna un nuevo tipo de pago a un cliente. Si el cliente ya tiene membrecías, puedes agregar otra más.',
    client: 'Cliente',
    paymentType: 'Tipo de Pago',
    discount: 'Descuento',
    isYearBased: 'Es por año',
    startFromPayment: 'Comenzar desde el pago',
    startFromNow: 'Desde ahora (primer pago)',
    startFromPaymentNumber: 'Pago #',
    applyMoraToPrevious: '¿Aplicar mora a los pagos pendientes anteriores?',
    startDate: 'Fecha de Inicio',
    endDate: 'Fecha de Fin',
    nextPayment: 'Próximo Pago',
    dates: 'Fechas',
    selectClient: 'Seleccionar Cliente',
    searchClient: 'Buscar cliente por nombre...',
    selectPaymentType: 'Seleccionar tipo de pago...',
    selectDiscount: 'Seleccionar descuento...',
    existingMemberships: 'Membrecías Existentes',
    noExistingMemberships: 'No hay membrecías existentes para este cliente. Se creará un nuevo registro.',
    membershipDetail: 'Detalle de Membrecía',
    searchPlaceholder: 'Buscar por cliente o tipo de pago...',
    noRecordsFound: 'No se encontraron membrecías',
    notFound: 'Membrecía no encontrada',
    suspend: 'Suspender',
    reactivate: 'Reactivar',
    suspensionInfo: 'Información de Suspensión',
    susStart: 'Inicio de Suspensión',
    susEnd: 'Fin de Suspensión',
    statusActive: 'Activo',
    statusSuspended: 'Suspendido',
    statusEnded: 'Finalizado',
    pleaseFillRequired: 'Por favor selecciona un cliente, tipo de pago y descuento',
    pleaseFillDates: 'Por favor completa las fechas de inicio y fin',
    createdSuccess: 'Membrecía asignada exitosamente',
    suspendedSuccess: 'Membrecía suspendida exitosamente',
    reactivatedSuccess: 'Membrecía reactivada exitosamente',
    errorLoading: 'Error al cargar membrecías',
    errorLoadingData: 'Error al cargar datos',
    errorSaving: 'Error al asignar membrecía',
    errorUpdating: 'Error al actualizar membrecía',
  },

  paymentTypes: {
    title: 'Tipos de Pago',
    newPaymentType: 'Nuevo Tipo de Pago',
    editPaymentType: 'Editar Tipo de Pago',
    savePaymentType: 'Guardar Tipo de Pago',
    updatePaymentType: 'Actualizar Tipo de Pago',
    deletePaymentType: 'Eliminar Tipo de Pago',
    deleteConfirm: '¿Estás seguro de que deseas eliminar este tipo de pago?',
    deletedPaymentTypes: 'Tipos de Pago Eliminados',
    restorePaymentType: 'Restaurar Tipo de Pago',
    restoreConfirm: '¿Estás seguro de que deseas restaurar este tipo de pago?',
    restore: 'Restaurar',
    amount: 'Monto',
    lateFee: 'Mora',
    lateFeeDays: 'Días de Mora',
    installments: 'Cuotas',
    frequency: 'Frecuencia',
    recurrence: 'Recurrencia',
    byDate: 'Por Fecha',
    indefinite: 'Indefinido',
    indefiniteHelp: 'Sin número fijo de pagos; el cliente paga por servicio y puede dejar de pagar en cualquier momento.',
    indefiniteLabel: 'Indefinido',
    monthly: 'Mensual',
    annual: 'Anual',
    daily: 'Diario',
    deletedAt: 'Eliminado el',
    searchPlaceholder: 'Buscar tipos de pago...',
    noPaymentTypesFound: 'No se encontraron tipos de pago',
    noDeletedFound: 'No se encontraron tipos de pago eliminados',
    pleaseFillRequired: 'Por favor complete los campos obligatorios',
    createdSuccess: 'Tipo de pago creado exitosamente',
    updatedSuccess: 'Tipo de pago actualizado exitosamente',
    deletedSuccess: 'Tipo de pago eliminado exitosamente',
    restoredSuccess: 'Tipo de pago restaurado exitosamente',
    errorLoading: 'Error al cargar tipos de pago',
    errorLoadingPaymentType: 'Error al cargar tipo de pago',
    errorDeleting: 'Error al eliminar tipo de pago',
    errorRestoring: 'Error al restaurar tipo de pago',
    errorSaving: 'Error al guardar tipo de pago',
  },

  payments: {
    title: 'Pagos',
    subtitle: 'Ver estado de pagos por cliente y membrecía. Verde = pagado, rojo = pendiente.',
    client: 'Cliente',
    membership: 'Membrecía',
    paymentsStatus: 'Estado de pagos',
    byYear: 'Por año',
    pending: 'pendientes',
    howManyInstallments: '¿Cuántas cuotas?',
    oneInstallment: 'cuota',
    installmentsLabel: 'cuotas',
    noPendingInstallments: 'No hay cuotas pendientes para esta membrecía.',
    cancelled: 'Cancelado',
    searchPlaceholder: 'Buscar por cliente o membrecía...',
    noRecordsFound: 'No se encontraron registros',
    registerPayment: 'Registrar Pago',
    selectMembership: 'Seleccionar membrecía',
    enterAmount: 'Ingrese un monto válido',
    selectMethod: 'Seleccione al menos un método de pago',
    amount: 'Monto',
    lateFee: 'Mora',
    cash: 'Efectivo',
    cheque: 'Cheque',
    card: 'Tarjeta',
    attachmentButton: 'Agregar adjunto',
    attachmentHelp: 'Archivo opcional (imagen/PDF) como comprobante del pago.',
    registeredSuccess: 'Pago registrado exitosamente',
    errorLoading: 'Error al cargar pagos',
    errorRegistering: 'Error al registrar pago',
    viewList: 'Lista',
    viewGrouped: 'Por cliente',
    filterByMembershipType: 'Tipo de membrecía',
    allMembershipTypes: 'Todos',
    oneMembership: '1 membrecía',
    manyMemberships: '{count} membrecías',
    paidCountLabel: '{count} pagos',
    paidCountSinceStart: '{count} pagos desde {date}',
    indefiniteOneAtATime: 'Solo el pago actual (1 cuota) para membrecías indefinidas.',
  },
};
